const lang = {
  // phan quyen
  // 'admin.customer.list': 'Xem danh sách khách hàng',
  // 'admin.customer.create': 'Thêm mới khách hàng',
  // 'admin.customer.detail': 'Xem chi tiết khách hàng',
  // 'admin.customer.update': 'Cập nhật thông tin khách hàng',
  // 'admin.customer.remove': 'Xoá khách hàng',
  // 'admin.customer.export': 'Download thông tin khách hàng',

  // 'admin.potential_customer.list': 'Xem danh sách khách hàng tiềm năng',
  // 'admin.potential_customer.create': 'Thêm mới khách hàng tiềm năng',
  // 'admin.potential_customer.detail': 'Xem chi tiết khách hàng tiềm năng',
  // 'admin.potential_customer.update': 'Cập nhật thông tin khách hàng tiềm năng',
  // 'admin.potential_customer.remove': 'Xoá khách hàng tiềm năng',

  // 'admin.customer_history.list': 'Xem lịch sử làm việc khách hàng',
  // 'admin.customer_history.create': 'Thêm mới lịch sử làm việc khách hàng',
  // 'admin.customer_history.remove': 'Xoá lịch sử làm việc khách hàng',

  // 'admin.datacenter_request.list': 'Xem danh sách yêu cầu Datacenter',
  // 'admin.datacenter_request.create': 'Thêm mới yêu cầu Datacenter',
  // 'admin.datacenter_request.detail': 'Xem chi tiết yêu cầu Datacenter',
  // 'admin.datacenter_request.remove': 'Xoá yêu cầu Datacenter',
  // 'admin.datacenter_request.export': 'Download danh sách yêu cầu Datacenter',

  // 'admin.documentation.list': 'Xem danh sách tài liệu',
  // 'admin.documentation.create': 'Thêm mới tài liệu',
  // 'admin.documentation.detail': 'Xem chi tiết tài liệu',
  // 'admin.documentation.update': 'Cập nhật thông tin tài liệu',
  // 'admin.documentation.remove': 'Xoá tài liệu',

  // 'admin.notification.list': 'Xem danh sách thông báo',
  // 'admin.notification.create': 'Thêm mới thông báo',
  // 'admin.notification.detail': 'Xem chi tiết thông báo',
  // 'admin.notification.update': 'Cập nhật thông báo',
  // 'admin.notification.remove': 'Xoá thông báo',

  // 'admin.partner.list': 'Xem danh sách đối tác',
  // 'admin.partner.create': 'Thêm mới đối tác',
  // 'admin.partner.detail': 'Xem chi tiết đối tác',
  // 'admin.partner.update': 'Cập nhật thông tin đối tác',
  // 'admin.partner.remove': 'Xoá đối tác',

  // 'admin.product.list': 'Xem danh sách dịch vụ',
  // 'admin.product.create': 'Thêm mới dịch vụ',
  // 'admin.product.detail': 'Xem chi tiết dịch vụ',
  // 'admin.product.update': 'Cập nhật thông tin dịch vụ',
  // 'admin.product.remove': 'Xoá dịch vụ',
  // 'admin.product.send_postage': 'Gửi thông báo cước dịch vụ',
  // 'admin.product.send_overload_alert': 'Gửi thông báo quá tải',
  // 'admin.product.export': 'Download danh sách dịch vụ',

  // 'admin.product_category.list': 'Xem danh sách danh mục dịch vụ',
  // 'admin.product_category.create': 'Thêm mới danh mục dịch vụ',
  // 'admin.product_category.detail': 'Xem chi tiết danh mục dịch vụ',
  // 'admin.product_category.update': 'Cập nhật thông tin danh mục dịch vụ',
  // 'admin.product_category.remove': 'Xoá danh mục dịch vụ',

  // 'admin.service.list': 'Xem danh sách sản phẩm',
  // 'admin.service.create': 'Thêm mới sản phẩm',
  // 'admin.service.detail': 'Xem chi tiết sản phẩm',
  // 'admin.service.update': 'Cập nhật thông tin sản phẩm',
  // 'admin.service.remove': 'Xoá sản phẩm',

  // 'admin.support_request.list': 'Xem danh sách yêu cầu hỗ trợ',
  // 'admin.support_request.create': 'Tạo yêu cầu hỗ trợ',
  // 'admin.support_request.detail': 'Xem chi tiết yêu cầu hỗ trợ',
  // 'admin.support_request.update': 'Cập nhật yêu cầu hỗ trợ',
  // 'admin.support_request.response': 'Phản hồi hỗ trợ',

  // 'admin.user.list': 'Xem danh sách user',
  // 'admin.user.create': 'Thêm mới user',
  // 'admin.user.detail': 'Xem chi tiết user',
  // 'admin.user.update': 'Cập nhật thông tin user',
  // 'admin.user.remove': 'Xoá user',

  // 'admin.permissions.list': 'Xem danh sách quyền',
  // 'admin.permissions.update': 'Phân quyền',
  // 'admin.permissions.get_by_role': 'Lấy danh sách quyền theo vai trò',

  // 'admin.task.list': 'Xem danh sách công việc hằng ngày',
  // 'admin.task.create': 'Thêm mới công việc hằng ngày',
  // 'admin.task.detail': 'Xem chi tiết công việc hằng ngày',
  // 'admin.task.update': 'Cập nhật thông tin công việc hằng ngày',
  // 'admin.task.remove': 'Xoá công việc hằng ngày',

  // 'admin.role.list': 'Xem danh sách vai trò',
  // 'admin.role.create': 'Thêm mới vai trò',
  // 'admin.role.detail': 'Xem chi tiết vai trò',
  // 'admin.role.update': 'Cập nhật thông tin vai trò',
  // 'admin.role.remove': 'Xoá vai trò',

  // 'admin.business.get_revenue_in_month': 'Xem báo cáo doanh thu trong tháng',
  // 'admin.business.get_report': 'Xem báo cáo của nhân viên',
  // 'admin.business.list_transaction': 'Xem lịch sử giao dịch',
  // 'admin.business.create_transaction': 'Tạo mới giao dịch',
  // 'admin.business.detail_transaction': 'Xem chi tiết giao dịch',
  // 'admin.business.update_transaction': 'Cập nhật giao dịch',
  // 'admin.business.remove_transaction': 'Xoá giao dịch',
  // 'admin.potential_customer.import': 'Import từ Excel',

  // 'admin.warehouse.list': 'Xem danh sách thiết bị trong kho',
  // 'admin.warehouse.create': 'Thêm mới thiết bị vào kho',
  // 'admin.warehouse.detail': 'Xem chi tiết thiết bị',
  // 'admin.warehouse.update': 'Cập nhật thông tin thiết bị',
  // 'admin.warehouse.remove': 'Xoá thiết bị',

  // 'admin.order.list': 'Xem danh sách yêu cầu mua hàng',
  // 'admin.order.detail': 'Xem chi tiết yêu cầu mua hàng',
  // 'admin.order.update': 'Cập nhật yêu cầu mua hàng',

  // 'admin.shop.list': 'Xem danh sách gian hàng đối tác',
  // 'admin.shop.create': 'Thêm mới gian hàng đối tác',
  // 'admin.shop.detail': 'Xem chi tiết gian hàng đối tác',
  // 'admin.shop.update': 'Cập nhật thông tin gian hàng đối tác',
  // 'admin.shop.remove': 'Xoá gian hàng đối tác',

  // 'admin.service_category.list': 'Xem danh sách danh mục sản phẩm',
  // 'admin.service_category.create': 'Thêm mới danh mục sản phẩm',
  // 'admin.service_category.detail': 'Xem chi tiết danh mục sản phẩm',
  // 'admin.service_category.update': 'Cập nhật thông tin danh mục sản phẩm',
  // 'admin.service_category.remove': 'Xoá danh mục sản phẩm',

  // 'admin.mail.send': 'Gửi mail tới khách hàng',
  // 'admin.mail.send_many': 'Gửi thông báo chăm sóc (tới nhiều khách hàng)',
  // 'admin.mail.get_template': 'Xem mẫu email',
  // 'admin.mail.set_template': 'Cập nhật mẫu email',

  // 'admin.web_customer.list': 'Xem danh sách khách hàng từ web',
  // 'admin.web_customer.detail': 'Xem chi tiết khách hàng từ web',
  // 'admin.web_customer.update': 'Cập nhật khách hàng từ web',
  // 'admin.web_customer.remove': 'Xoá khách hàng từ web',

  // 'admin.export.customer': 'Download dữ liệu khách hàng',
  // 'admin.export.product':
  //   'Download dữ liệu dịch vụ (bao gồm đang chạy, cắt huỷ, tạm dừng)',
  // 'admin.export.datacenter_request': 'Download yêu cầu datacenter',
  // 'admin.export.support_request': 'Download yêu cầu hỗ trợ từ khách hàng',
  // 'admin.export.customer_history': 'Download lịch sử làm việc với khách hàng',
  // 'admin.export.product_history': 'Download lịch sử thay đổi dịch vụ',
  // 'admin.export.product_overload': 'Download thông báo dịch vụ quá tải',
  // 'admin.product_overload.list': 'Xem danh sách thông báo quá tải',

  // 'admin.customer_support_calls.list': 'Xem danh sách khách hàng cần chăm sóc',
  // 'admin.customer_support_calls.create': 'Tạo ghi chú sau khi chăm sóc',

  // card title
  // 'admin.customer': 'Khách hàng',
  // 'admin.customer_history': 'Lịch sử làm việc khách hàng',
  // 'admin.datacenter_request': 'Yêu cầu datacenter',
  // 'admin.documentation': 'Tài liệu',
  // 'admin.notification': 'Thông báo khuyến mãi',
  // 'admin.partner': 'Đối tác datacenter',
  // 'admin.permissions': 'Phân quyền',
  // 'admin.potential_customer': 'Khách hàng tiềm năng',
  // 'admin.product': 'Dịch vụ',
  // 'admin.product_category': 'Danh mục dịch vụ',
  // 'admin.role': 'Quản lý vai trò',
  // 'admin.service': 'Sản phẩm đối tác',
  // 'admin.support_request': 'Yêu cầu hỗ trợ',
  // 'admin.task': 'Công việc hằng ngày',
  // 'admin.user': 'User',
  // 'admin.warehouse': 'Kho thiết bị',
  // 'admin.business': 'Báo cáo kinh doanh',
  // 'admin.shop': 'Gian hàng đối tác',
  // 'admin.order': 'Yêu cầu mua hàng',
  // 'admin.service_category': 'Danh mục sản phẩm đối tác',
  // 'admin.mail': 'Mail',
  // 'admin.web_customer': 'Khách hàng từ web',
  // 'admin.export': 'Download dữ liệu',
  // 'admin.product_overload': 'Thông báo quá tải',
  // 'admin.customer_support_calls': 'Chăm sóc khách hàng',
  // 'global.avatar': 'Ảnh',
  // 'global.full_name': 'Họ tên',
  // 'global.created': 'Ngày đăng kí',
  'global.friendly_code': 'Friendly code',
  'global.organization_application': 'Organization Application',
  'global.seed_buyer': 'Seed Buyer',
  'global.request_seed_title': 'Request Seed',
  'onboarding_chat.menu': 'Onboarding Chat',
  'onboarding_chat.title': 'Onboarding Chat (Multi-Me)',
  'onboarding_chat.tab_accounts': 'Sender Accounts',
  'onboarding_chat.tab_messages': 'Message Templates',
  'onboarding_chat.tab_settings': 'Delay Settings',
  'onboarding_chat.add_account': 'Add Sender Account',
  'onboarding_chat.edit_account': 'Edit Sender Account',
  'onboarding_chat.add_message': 'Add Message Template',
  'onboarding_chat.edit_message': 'Edit Message Template',
  'onboarding_chat.category': 'Category',
  'onboarding_chat.message_content': 'Message content',
  'onboarding_chat.sort_order': 'Sort order',
  'onboarding_chat.enabled': 'Enable Message 2 & 3',
  'interview_question.menu_group': 'Voice Onboarding',
  'interview_question.menu': 'Interview Questions',
  'interview_question.code': 'Code',
  'interview_question.content': 'Content',
  'interview_question.purpose': 'Purpose (admin note)',
  'interview_question.sort_order': 'Sort order',
  'interview_question.translations': 'Translations',
  'interview_question.add_question': 'Add Interview Question',
  'interview_question.edit_question': 'Edit Interview Question',
  'interview_question.detail_tab': 'Details',
  'interview_question.translations_tab': 'Translations',
  'interview_question.locale': 'Language',
  'interview_question.translated_content': 'Translated content (optional)',
  'interview_question.translation_file': 'Translation file (optional)',
  'interview_question.upload_file': 'Upload file',
  'interview_question.save_translation': 'Save translation',
  'interview_question.reorder_questions': 'Reorder interview questions',
  'interview_question.save_order': 'Save order',
  'interview_question.order_updated': 'Ordering updated successfully',
  'interview_question.failed_to_update_order': 'Failed to update ordering',
  'interview_question.failed_to_load_for_ordering': 'Failed to load questions for ordering',
  'interview_question.used_in_flows': 'Used in flows',
  'interview_question.used_in_flows_tooltip': 'Managed from Seller Interview > Seller Interview Flows',
  'interview_flow.menu': 'Seller Interview Flows',
  'interview_flow.no_questions': 'No questions selected. Add questions from the library.',
  'interview_flow.add_questions': 'Add questions',
  'interview_flow.library_hint': 'Select existing questions from your question library.',
  'interview_flow.add_selected': 'Add selected questions',
  'interview_flow.search_questions': 'Search question text or code',
  'interview_session.menu': 'Interview Sessions',
  'interview_session.seller': 'Seller',
  'interview_session.progress': 'Progress',
  'interview_session.question_count': 'Questions',
  'interview_session.filter_by_status': 'Filter by status',
  'interview_session.detail_title': 'Interview Session Detail',
  'global.organization_invitations': 'Organization Invitations',
  'global.organization': 'Organization',
  'global.seller': 'Seller',
  'global.invited_by': 'Invited By',
  'global.search_by_organization': 'Search by Organization Name',
  'global.filter_by_status': 'Filter by Status',
  'global.accepted': 'Accepted',
  'global.rejected': 'Rejected',
  'global.expired': 'Expired',
  'global.cancelled': 'Cancelled',
  'global.action': 'Action',
  'global.confirm_cancel_invitation':
    'Are you sure you want to cancel this invitation?',
  'global.role': 'Roles',
  'global.app-all': 'Apps',
  'global.config': 'Config',
  'global.add': 'Add New',
  'global.pending': 'Pending',
  'global.activated': 'Activated',
  'global.blocked': 'Blocked',
  'global.edit': 'Edit',
  'global.password': 'Password',
  'global.resetpassword': 'Reset password',
  'global.input_password': 'Input password',
  'global.is_verified_email': 'Verify email',
  'global.is_mobile_verified': 'Verify phone',
  'global.unverified': 'Unverified',
  'global.verified': 'Verified',
  'global.role_apps': 'Role apps',
  'global.admin': 'Admin',
  'global.network': 'Network',
  'global.shop': 'Shop',
  'global.sent_at': 'Sent at',
  'global.reset_password': 'Reset Password',
  'global.data': 'Data',
  'global.seller_management_certificate': 'Certificate',
  'global.seller_management_sale_user_name': 'Sale user',
  'global.seller_management_avatar': 'Avatar',
  'global.bio': 'Bio',
  'global.resetPassword': 'Reset Password',
  // 'global.admin': 'Quản trị viên',
  // 'global.staff': 'Nhân viên',
  // 'global.gender': 'Giới tính',
  // 'global.date_of_bird': 'Date of birth',
  // 'global.identity': 'CMT/CCCD',
  // 'global.bhyt': 'BHYT',
  // 'global.nam': 'Nam',
  // 'global.nu': 'Nữ',
  // 'global.ngay_cap': 'Ngày cấp',
  // 'global.noi_cap': 'Nơi cấp',5
  // 'global.so_bhyt': 'Số BHYT',
  // 'widgets.recentNotifications': 'Thông báo gần đây',
  // 'button.viewAll': 'Xem tất cả',
  // 'widgets.recentMessage': 'Tin nhắn gần đây',
  // 'global.user': 'Người dùng',
  'global.budget_remaining_total': 'Budget (Remaining / Total)',
  'global.valid_period': 'Valid Period (Start / End)',
  'global.edit_voucher': 'Edit voucher',
  'global.usage': 'Usage (Used / Total)',
  'global.status': 'Status',
  'global.participants': 'Participants',
  'global.last_message': 'Last message',
  'global.message': 'Message',
  'global.last_activity': 'Last activity',
  'global.type_chat': 'Type chat',
  'global.chat_manager': 'Chat manager',
  'global.chat': 'Chat',
  'global.see-more': 'See more',
  'global.hide-less': 'See less',
  'global.notifications': 'Notifications',
  'global.notification_manager': 'Notification Manager',
  'global.mark_all_as_read': 'Mark all as read',
  'global.user_avatar': 'Avatar',
  'global.select_language': 'Select language',
  'global.delete_success': 'Delete successful!',
  'global.status': 'Status',
  'global.add_new': 'Add new',

  'global.published': 'Published',
  'global.unpublished': 'Unpublished',
  'global.delete': 'Delete',
  'global.clear_deleted': 'Clear deleted',
  'global.clear_deleted_confirm':
    'Hide all deleted accounts (deleted-user-*) from the admin list? This sets deleted_at on those accounts.',
  'global.clear_deleted_result': 'Hid {count} deleted account(s)',
  'global.copy': 'Copy',
  'global.create': 'Create',
  'global.update': 'Update',
  'global.image': 'Image',
  'global.images': 'Images',
  'global.select_image': 'Select Image',
  'global.image_alt': 'Alternative image',
  'global.schema_type': 'Schema type',
  'global.title': 'Title',
  'global.reference': 'Reference',
  'global.slug': 'Slug',
  'global.sub_title': 'Sub title',
  'global.company': 'Company',
  'global.id': 'ID',
  'global.tabbasic': 'Basic',
  'global.alias': 'Alias',
  'global.description': 'Description',
  'global.cancel': 'Cancel',
  'global.active': 'Active',
  'global.deactivate': 'Deactivate',
  'global.submit': 'Submit',
  'global.edit': 'Edit',
  'global.trashed': 'Trashed',
  'global.approved': 'Approved',
  'global.approve': 'Approve',
  'global.from': 'From',
  'global.to': 'To',
  'global.price_discount': 'Price discount',
  'global.price_roundtrip': 'Price roundtrip',
  'global.price': 'Price',
  'global.duration_months': 'Duration (Months)',
  'global.please_input_price': 'Please input price',
  'global.please_input_duration_months': 'Please input duration (months)',
  'global.infant_price': 'Infant price',
  'global.car': 'Car',
  'global.type': 'Type',
  'global.rating': 'Rating',
  'global.room_rate': 'Room rate',
  'global.cancel_policy': 'Cancel policy',
  'global.instant_bookable': 'Instant bookable',
  'global.yes': 'Yes',
  'global.no': 'No',
  'global.city': 'City',
  'global.street': 'Street',
  'global.neighbourhood_cleansed': ' Cleansed',
  'global.neighbourhood_group_cleansed': ' Group cleansed',
  'global.location': 'Location',
  'global.choose-location': 'Choose location',
  'global.square_feet': 'Square Feet',
  'global.bedrooms': 'Bedrooms',
  'global.bathrooms': 'Bathrooms',
  'global.beds': 'Beds',
  'global.bed_type': 'Bed_type',
  'global.cover_img': 'Cover image',
  'global.gallery': 'Gallery',
  'global.gallerySetting': 'Gallery Setting',
  'global.security_deposit': 'Security deposit ',
  'global.guests_included': 'Guests included',
  'global.minimum_nights': 'Minimum nights',
  'global.cleaning_fee': 'Cleaning fee',
  'global.extra_people': 'Extra people',
  'global.maximum_nights': 'Maximum nights',
  'global.months': 'Months',
  'global.calendar': 'Calendar',
  'global.province': 'Province',
  'global.district': 'District',
  'global.ward': 'Ward',
  'global.no_house': 'House number',
  'global.nearbyUtils': 'Near by utils',
  'global.extra_price': 'Extra price',
  'global.patients': 'Patients',
  'global.setting': 'Setting',
  'global.appointments': 'Appointments',
  'global.supplier': 'Suppliers',
  'global.id_number': 'ID',
  'global.code': 'Code',
  'global.name': 'Name',
  'global.services': 'Services',
  'global.clinic': 'Clinic',
  'global.website': 'Website',
  'global.contact_name': 'Contact',
  'global.refresh': 'Refresh',
  'global.distance': 'Distance',
  'global.save_experience': 'Save Experience',
  'global.save_education': 'Save Education',
  'global.save_address': ' Save Address',
  'global.save_save_bank_account': 'Save Bank Account',
  'global.save_certificate': 'Save Certificate',
  // card title
  // 'admin.customer': 'Khách hàng',
  // 'admin.customer_history': 'Lịch sử làm việc khách hàng',
  // 'admin.datacenter_request': 'Yêu cầu datacenter',
  // 'admin.documentation': 'Tài liệu',
  // 'admin.notification': 'Thông báo khuyến mãi',
  // 'admin.partner': 'Đối tác datacenter',
  // 'admin.permissions': 'Phân quyền',
  // 'admin.potential_customer': 'Khách hàng tiềm năng',
  // 'admin.product': 'Dịch vụ',
  // 'admin.product_category': 'Danh mục dịch vụ',
  // 'admin.role': 'Quản lý vai trò',
  // 'admin.service': 'Sản phẩm đối tác',
  // 'admin.support_request': 'Yêu cầu hỗ trợ',
  // 'admin.task': 'Công việc hằng ngày',
  // 'admin.user': 'User',
  // 'admin.warehouse': 'Kho thiết bị',
  // 'admin.business': 'Báo cáo kinh doanh',
  // 'admin.shop': 'Gian hàng đối tác',
  // 'admin.order': 'Yêu cầu mua hàng',
  // 'admin.service_category': 'Danh mục sản phẩm đối tác',
  // 'admin.mail': 'Mail',
  // 'admin.web_customer': 'Khách hàng từ web',
  // 'admin.export': 'Download dữ liệu',
  // 'admin.product_overload': 'Thông báo quá tải',
  // 'admin.customer_support_calls': 'Chăm sóc khách hàng',
  // 'global.avatar': 'Ảnh',
  // 'global.full_name': 'Họ tên',
  // 'global.created': 'Ngày đăng kí',
  'global.role': 'Roles',
  'global.app-all': 'Apps',
  'global.config': 'Config',
  'global.add': 'Add New',
  'global.pending': 'Pending',
  'global.request_seller': 'Request Seller',
  'global.request_seller_manager': 'Request seller manager',
  'global.declined': 'Declined',
  'global.activated': 'Activated',
  'global.blocked': 'Blocked',
  'global.edit': 'Edit',
  'global.password': 'Password',
  'global.resetpassword': 'Reset password',
  'global.input_password': 'Input password',
  'global.is_verified_email': 'Verify email',
  'global.is_mobile_verified': 'Verify phone',
  'global.unverified': 'Unverified',
  'global.verified': 'Verified',
  'global.role_apps': 'Role apps',
  'global.admin': 'Admin',
  'global.network': 'Network',
  'global.shop': 'Shop',
  'global.sent_at': 'Sent at',
  'global.data': 'Data',
  'global.seller_management_certificate': 'Certificate',
  'global.seller_management_avatar': 'Avatar',
  'global.bio': 'Bio',
  // 'global.admin': 'Quản trị viên',
  // 'global.staff': 'Nhân viên',
  // 'global.gender': 'Giới tính',
  // 'global.date_of_bird': 'Date of birth',
  // 'global.identity': 'CMT/CCCD',
  // 'global.bhyt': 'BHYT',
  // 'global.nam': 'Nam',
  // 'global.nu': 'Nữ',
  // 'global.ngay_cap': 'Ngày cấp',
  // 'global.noi_cap': 'Nơi cấp',5
  // 'global.so_bhyt': 'Số BHYT',
  // 'widgets.recentNotifications': 'Thông báo gần đây',
  // 'button.viewAll': 'Xem tất cả',
  // 'widgets.recentMessage': 'Tin nhắn gần đây',
  // 'global.user': 'Người dùng',
  // 'global.status': 'Trạng thái',
  'global.participants': 'Participants',
  'global.last_message': 'Last message',
  'global.message': 'Message',
  'global.last_activity': 'Last activity',
  'global.type_chat': 'Type chat',
  'global.chat_manager': 'Chat manager',
  'global.chat': 'Chat',
  'global.see-more': 'See more',
  'global.hide-less': 'See less',
  'global.notifications': 'Notifications',
  'global.notification_manager': 'Notification Manager',
  'global.mark_all_as_read': 'Mark all as read',
  'global.user_avatar': 'Avatar',
  'global.delete_success': 'Delete successfully!',
  'global.status': 'Status',
  'global.add_new': 'Add new',
  'global.published': 'Published',
  'global.unpublished': 'Unpublished',
  'global.delete': 'Delete',
  'global.clear_deleted': 'Clear deleted',
  'global.clear_deleted_confirm':
    'Hide all deleted accounts (deleted-user-*) from the admin list? This sets deleted_at on those accounts.',
  'global.clear_deleted_result': 'Hid {count} deleted account(s)',
  'global.copy': 'Copy',
  'global.create': 'Create',
  'global.update': 'Update',
  'global.image': 'Image',
  'global.select_image': 'Select Image',
  'global.image_alt': 'Alternative image',
  'global.schema_type': 'Schema type',
  'global.title': 'Title',
  'global.slug': 'Slug',
  'global.sub_title': 'Sub title',
  'global.company': 'Company',
  'global.id': 'ID',
  'global.tabbasic': 'Basic',
  'global.alias': 'Alias',
  'global.description': 'Description',
  'global.cancel': 'Cancel',
  'global.active': 'Active',
  'global.deactivate': 'Deactivate',
  'global.submit': 'Submit',
  'global.edit': 'Edit',
  'global.trashed': 'Trashed',
  'global.approved': 'Approved',
  'global.approve': 'Approve',
  'global.from': 'From',
  'global.to': 'To',
  'global.price_discount': 'Price discount',
  'global.price_roundtrip': 'Price roundtrip',
  'global.price': 'Price',
  'global.infant_price': 'Infant price',
  'global.car': 'Car',
  'global.type': 'Type',
  'global.rating': 'Rating',
  'global.room_rate': 'Room rate',
  'global.cancel_policy': 'Cancel policy',
  'global.instant_bookable': 'Instant bookable',
  'global.yes': 'Yes',
  'global.no': 'No',
  'global.city': 'City',
  'global.street': 'Street',
  'global.neighbourhood_cleansed': ' Cleansed',
  'global.neighbourhood_group_cleansed': ' Group cleansed',
  'global.location': 'Location',
  'global.choose-location': 'Choose location',
  'global.square_feet': 'Square Feet',
  'global.bedrooms': 'Bedrooms',
  'global.bathrooms': 'Bathrooms',
  'global.beds': 'Beds',
  'global.bed_type': 'Bed_type',
  'global.cover_img': 'Cover image',
  'global.gallery': 'Gallery',
  'global.gallerySetting': 'Gallery Setting',
  'global.security_deposit': 'Security deposit ',
  'global.guests_included': 'Guests included',
  'global.minimum_nights': 'Minimum nights',
  'global.cleaning_fee': 'Cleaning fee',
  'global.extra_people': 'Extra people',
  'global.maximum_nights': 'Maximum nights',
  'global.months': 'Months',
  'global.calendar': 'Calendar',
  'global.province': 'Province',
  'global.district': 'District',
  'global.ward': 'Ward',
  'global.no_house': 'House number',
  'global.nearbyUtils': 'Near by utils',
  'global.extra_price': 'Extra price',
  'global.patients': 'Patients',
  'global.setting': 'Setting',
  'global.appointments': 'Appointments',
  'global.supplier': 'Suppliers',
  'global.id_number': 'ID',
  'global.code': 'Code',
  'global.name': 'Name',
  'global.services': 'Services',
  'global.clinic': 'Clinic',
  'global.website': 'Website',
  'global.contact_name': 'Contact',
  'global.refresh': 'Refresh',
  'global.distance': 'Distance',
  'global.save_experience': 'Save Experience',
  'global.save_education': 'Save Education',
  'global.save_address': ' Save Address',
  'global.save_save_bank_account': 'Save Bank Account',
  'global.save_certificate': 'Save Certificate',

  'car.driver': 'Driver',
  'car.seat': 'Seat',
  'car.luggage': 'Luggage',
  'car.ordering': 'Booking',
  'car.facility': 'Facility',
  'car.air_machine': 'Air machine',
  'car.energy_saving': 'Energy saving',
  'car.stop_point': 'Stop point',
  'property.start_date_end_date': 'Start / End date',
  'property.start_date': 'Start date',
  'property.end_date': 'End date',
  'property.price_week': 'Price week',
  'property.weekend_price': 'Price weekend',
  'property.extra_price': 'Extra price',
  'property.host_languages': ' Host languages',
  'property.week_term_promo': 'Week term promo',
  'property.month_term_promo': 'Month term promo',
  'property.price_weekend': 'Price weekend',
  'global.guests_standard': 'Guests standard',
  'global.guests_max': 'Guests max',
  'sidebar.transport': 'Transport',
  'sidebar.amenity': 'Amenity',
  'sidebar.restaurant': 'Restaurant',
  'sidebar.property': 'Property',
  'sidebar.property_type': 'Property type',
  'sidebar.room': 'Room',
  'sidebar.cancel_policy': 'Cancel policy',
  'sidebar.vehicle': 'Vehicle',
  'sidebar.car': 'Car',
  'sidebar.route': 'Route',
  'sidebar.routes': 'Routes',
  'sidebar.inbox': 'Inbox',
  'sidebar.conversation': 'Conversation',
  'sidebar.reservations': 'Reservations',
  'sidebar.earning': 'Earning',
  'sidebar.calendar': 'Calendar',
  'sidebar.reports': 'Reports',
  'sidebar.services': 'Services',
  'sidebar.addons_order': 'Additional services',
  'sidebar.debt_confirmation_record': 'Debt confirmation record',
  'global.requiredfield': 'Required field',

  'property.room_type': 'Room type',
  'global.propertytypes': 'Property type',
  'global.save': 'Save',
  'global.save_and_close': 'Save & close',
  'global.signin': 'Sign in',
  'global.signup': 'Signup',
  'global.forgot_password': 'Forgot password',
  'global.search_placeholder': 'Search',

  //Tour
  'global.duration': 'Duration',
  'global.routes': 'Routes',
  'global.category': 'Category',
  'global.cover_image': 'Cover',
  'global.url': 'Image url',
  'global.operator': 'Operator',
  'global.from_price': 'Prices',
  'global.itinerary': 'Itinerary',
  'global.itineraries': 'Itineraries',
  'global.updated_at': 'Updated',
  'global.last_login_at': 'Last login',
  'global.from_priceMGMT': 'Prices',
  'global.from_price_setting': ' Prices setting',
  'global.tours': 'Tours',
  'global.tour_id': 'Tour id',
  'global.transportation': 'Transportation',
  'global.score': 'Score',
  'global.tour_option': 'Tour options',
  'global.hourly': 'Hourly',
  'tour.title': 'Title',
  'tour.private_tour': 'Private tour',
  'tour.start_time_required': 'Start time or pickup time required?',
  'global.select_category': 'Select category',
  'global.select_seller_send': 'Check the box to select one or more experts',
  'global.select_operator': 'Select operator',
  'global.select_cabin_type': 'Select cabin type',
  'tour.description': 'Tour description',
  'tour.inclusion': 'Inclusion',
  'tour.exclusion': 'Exclusion',
  'global.inactive': 'Inactive',
  'global.meal': 'Meals',
  'global.category_operator': 'Category and operator',
  'tour.pricing': 'Pricing model',
  'tour.special': 'Special',
  'tour.normal': 'Normal',
  'tour.featured': 'Featured',
  'tour.time_mgmt': 'Time management',
  'tour.duration_unit': 'Duration unit',
  'tour.duration': 'Duration',
  'tour.start_time': 'Start time',
  'tour.instant_confirm': 'Instant confirm',
  'global.delete_confirm': 'Are you sure want to delete this item?',
  'global.cancel_order': 'Are you sure want to cancel this item?',
  'tour.gallery': 'Gallery',
  'global.ticket': 'Ticket',
  'global.min_person': 'Min person',
  'global.freeCancelHours': 'Free cancel hours',
  'global.freeCancel': 'Free cancel',
  'tour.freeCancel': 'Free cancel',
  'global.cancelPolicy': 'Cancel policy',
  'global.meeting': 'Meeting point',
  'global.meetingPoint': 'Meeting point',
  'global.meeting_point': 'Meeting point',
  'global.meeting_point_type': 'Meeting point type',
  'global.meetingPointNotes': 'Meeting point notes',
  'tour.cutOffTime': 'Cut off time(hours)',
  'tooltip.cutOffTime': 'e.g: 2 days before departure date is 48 hours',
  'global.perPerson': 'Per person',
  'global.perGroup': 'Per group',
  'global.optionTitle': 'Option title',
  'global.checkall': 'Check all',

  //Option
  'global.max_person': 'Max person',
  'global.max': 'Max',
  'global.adult_price': 'Adult price',
  'global.child_price': 'Child price',
  'global.cost_price': 'Cost price',
  'global.cost': 'Cost',
  'global.selling_price': 'Selling price',
  'global.selling': 'Selling',
  'global.cost_price_notes': 'Cost price notes',
  'global.select_tour': 'Select tour',
  'global.option': 'Option',
  'global.options': 'Options',
  'option.group': 'Group',
  'global.Vehicle_type': 'Vehicle type',
  'global.timeStart': 'Time start',
  'global.startWorkingTime': 'Start working time',
  '.endWorkingTime': 'End working time',

  'global.tour_type': 'Tour type',

  //Destination
  'global.destination': 'Destination',
  'global.select_destination': 'Select destination',
  'global.countries': 'Countries',
  'global.select_country': 'Select country',
  'destination.longitude': 'Longitude',
  'destination.latitude': 'Latitude',
  'global.destination_parent': 'Destination parent',

  //Categories
  'global.categories': 'Categories',

  //Operators
  'global.operators': 'Operators',
  'global.firstname': 'First name',
  'global.lastname': 'Last name',
  'global.email': 'Email',
  'global.phone': 'Phone',
  'global.hotline': 'Hotline',

  //Currencies
  'global.currencies': 'Currencies',
  'currency.name': 'Name',
  'currency.display': 'Display',
  'currency.exchange_rate': 'Exchange rate',
  'currency.thousand': 'Format',
  'currency.image': 'Icon',
  'currency.symbol': 'Symbol',
  //post
  'global.posts': 'Posts',
  'post.fulltext': 'Full Text',
  'post.short': 'Short',
  'global.featured': 'Featured',
  'post.hit': 'Hit',
  'post.metadesc': 'Meta desc',
  'post.metakey': 'Meta key',
  'post.image': 'Image',

  //Log-in Log-out
  'global.account_information': 'Account information',
  'global.signout': 'Sign out',
  'global.email_required': 'Email required',
  'global.password_required': 'Password required',
  'global.email_not_valid': 'Email not valid',

  //Site:
  'global.site': 'Site',
  'sites.hotline': 'Hotline',
  'sites.locale': 'Locale',
  'sites.from_email': 'From email',
  'sites.from_name': 'From name',
  'sites.currency': 'Currency',
  'sites.timezone': 'Time zone',
  'sites.meta_description': 'Meta description',
  'sites.meta_title': 'Meta title',
  'sites.email': 'Email',
  'global.sites': 'Sites',
  //Bookings:
  'global.order': 'Booking',
  'global.orderId': 'Booking ID',
  'order.tour_title': 'Tour title',
  'order.route_title': 'Title',
  'order.pay_status': 'Pay status',
  'order.order_status': 'Booking status',
  'order.depart_date': 'Depart date',
  'order.customer': 'Customer',
  'order.totalTravelers': 'Total traveler',
  'order.totalPrice': 'Total price',
  'order.created': 'Booked at',
  'order.created_by': 'Created by',
  'order.create': 'Create booking',
  'order.order_seat': 'Seat Allocation',
  'global.one_way': 'One way',
  'global.two_way': 'Two way',
  'global.time': 'Time',
  'global.search': 'Search',
  'global.departure': 'Departure',
  'global.return': 'Return',
  'global.assign_operator': 'Assign operator',
  'global.assign': 'Assign',
  'global.total': 'Total',
  'global.group_code': 'Code',
  'order.depart/return': 'Depart / Return',
  //Customers:
  'global.customers': 'Customers',
  'global.fullname': 'Full name',
  'global.userId': 'User ID',
  'global.company_name': 'Company name',
  'global.company_shortname': 'Short name',
  'global.company_tax_id': 'Tax code',
  'global.address': 'Address',
  'global.stock_quantity': 'Stock quantity',
  'global.is_active': 'Is active',
  'global.expiry_date': 'Expiry date',
  'global.manufacture_date': 'Manufacture',
  'global.manufacture_expiry_dates': 'Manufacture / Expiry Dates',
  'global.country_of_origin': 'Country of origin',
  'global.license_no': 'License no',
  'global.license_file': 'License file',
  'global.pricing_tiers': 'Pricing tiers',

  //Users:
  'global.roles': 'Roles',
  'global.menus': 'Menu Manager',

  'global.users': 'Users',
  'global.role': 'Role',
  'global.email_invalid': 'Email is invalid',
  'global.phone_invalid': 'Phone number is invalid',
  'global.phone_min_length': 'Phone number must be at least 10 digits',
  'global.phone_max_length': 'Phone number must be at most 15 digits',
  'global.password_min_length': 'Password must be at least 6 characters',
  //Schedule
  'global.schedule_setting': 'Schedule setting',
  'global.schedule': 'Schedule',
  'global.start_date': 'Start date',
  'global.end_date': 'End date',
  'global.start_date_created': 'Start date (Created)',
  'global.end_date_created': 'End date (Created)',
  'global.start_date_login': 'Start date (Login)',
  'global.end_date_login': 'End date (Login)',
  'global.weekdays': 'Week days',

  //wishlist
  'global.wishlist': 'Wishlist',
  'wishlist.tour_title': 'Tour title',
  'wishlist.customer': 'Customer',
  'global.basic': 'Basic',
  'global.item': 'Item',
  'global.items': 'Items',
  'global.sku': 'SKU',
  'global.skus': 'Sku',
  'global.widgets': 'Widgets',
  'global.widget': 'Widget',

  //menus
  'global.menus': 'Menus',
  'global.menu': 'Menu',
  'global.key': 'Key',
  'global.menu_items': 'Menu items',
  'global.menu_item': 'Menu item',

  // faq
  'global.faq': 'FAQs',
  'global.question': 'Question',
  'global.answer': 'Answer',
  'global.sequence': 'Order',

  //Register
  'global.registration_header': 'Register form',
  'global.country': 'Country',
  'global.mobile': 'Mobile',
  'signup.back_to_login': 'Back to login',
  'global.continue': 'Continue',
  'global.close': 'Close',

  //
  'global.statistics': 'Statistics',
  'global.tour_rates': 'Rates',
  'global.tour_options': 'Options',
  'global.destinations': 'Destinations',
  'global.orders': 'Bookings',
  'global.reviews': 'Reviews',
  'global.reviewer': 'Reviewer',

  'global.language': 'Language',
  'global.currency': 'Currency',
  'global.your_plan': 'Plan',
  'global.trial_end': 'Expired date',
  'global.timezone': 'Timezone',
  'global.emai_required': 'Yêu cầu điền email',
  // 'global.password_required': 'Yêu cầu điền mật khẩu',
  'global.emai_not_valid': 'Email không đúng định dạng',
  'global.confirm_password': 'Confirm password',
  'global.confirm_password_placeholder': 'input confirm password',
  'global.changepassword': 'Change password',
  'global.confirm_new_password': 'Confirm new password',
  'global.new_password': 'New password',
  'global.current_password': 'Current password',
  'global.password_not_match': 'Password not match',
  'global.password_min_charactor': '6 characters min',
  'global.home': 'Home',
  'global.vouchers': 'Vouchers',
  'sidebar.vouchers': 'Voucher Management',
  'voucher.title': 'Voucher Management',
  'global.voucher_saved': 'Voucher saved successfully',
  'global.failed_to_save_voucher': 'Failed to save voucher',

  // Voucher Form
  'voucher.code': 'Voucher Code',
  'voucher.code_required': 'Please enter voucher code',
  'voucher.code_max_length': 'Code cannot exceed 50 characters',
  'voucher.code_note':
    'The code that users will enter during checkout (e.g., SUMMER2024, SAVE50)',
  'voucher.code_placeholder': 'Enter voucher code (e.g., SUMMER2024)',
  'voucher.name_required': 'Please enter voucher name',
  'voucher.name_note':
    'Display name of the voucher, a brief description of the promotion',
  'voucher.name_placeholder': 'Enter voucher name (e.g., Summer Sale 50% Off)',
  'voucher.description_note':
    'Detailed description of the voucher, terms and conditions, and other important information',
  'voucher.description_placeholder':
    'Enter detailed description about the voucher and terms of use',
  'voucher.reason': 'Reason',
  'voucher.reason_note':
    'Reason for creating this voucher (for internal management and reporting purposes)',
  'voucher.reason_placeholder':
    'Enter reason for creating voucher (e.g., Black Friday promotion, Customer appreciation program)',
  'voucher.is_private': 'Privacy',
  'voucher.privacy_note':
    'Private: Voucher is only for specified users. Public: All users can use this voucher',
  'voucher.private': 'Private',
  'voucher.public': 'Public',
  'voucher.budget': 'Budget',
  'voucher.budget_note':
    'Total maximum budget for this voucher. When the total discount amount reaches the budget, the voucher will automatically stop working',
  'voucher.budget_min_error': 'Budget must be greater than or equal to 0',
  'voucher.budget_placeholder': 'Enter total budget (e.g., 10000000)',
  'voucher.spent': 'Spent',
  'voucher.spent_note':
    "Total amount spent from this voucher's budget (read-only)",
  'voucher.remaining_budget': 'Remaining Budget',
  'voucher.remaining_budget_note':
    'Remaining amount in budget = Budget - Spent (read-only)',
  'voucher.auto_calculated': 'Auto calculated',
  'voucher.discount_type': 'Discount Type',
  'voucher.discount_type_required': 'Please select discount type',
  'voucher.discount_type_note':
    'Percent (%): Discount by percentage. Fixed Amount: Discount by fixed amount',
  'voucher.discount_type_placeholder': 'Select discount type',
  'voucher.discount_type_percent': 'Percent (%)',
  'voucher.discount_type_fixed': 'Fixed Amount',
  'voucher.discount_value': 'Discount Value',
  'voucher.discount_value_required': 'Please enter discount value',
  'voucher.discount_value_note':
    'If Percent: enter percentage (1-100). If Fixed Amount: enter fixed discount amount',
  'voucher.discount_value_min_error': 'Discount value must be greater than 0',
  'voucher.discount_value_placeholder':
    'Enter discount value (e.g., 50 for 50% or 50000 for 50,000)',
  'voucher.percentage_max_error': 'Percentage cannot exceed 100%',
  'voucher.min_order_value': 'Min Order Value',
  'voucher.min_order_value_note':
    'Minimum order value required to apply this voucher. Set to 0 if no minimum requirement',
  'voucher.min_order_value_placeholder':
    'Enter minimum order value (e.g., 200000)',
  'voucher.max_discount': 'Max Discount',
  'voucher.max_discount_note':
    'Maximum discount amount when using percentage voucher. Example: 50% off but maximum 100,000',
  'voucher.max_discount_placeholder':
    'Enter maximum discount amount (e.g., 100000)',
  'voucher.user_type': 'User Type',
  'voucher.user_type_required': 'Please select user type',
  'voucher.user_type_note':
    'Select user type that can use this voucher: All (everyone), Become Seller (sellers only), Offer Checkout (buyers only)',
  'voucher.user_type_placeholder': 'Select user type',
  'voucher.user_type_all': 'All',
  'voucher.user_type_seller': 'Become Seller',
  'voucher.service_purchase': 'Service Purchase',
  'voucher.max_use_per_user': 'Max Use Per User',
  'voucher.max_use_per_user_note':
    'Maximum number of times each user can use this voucher. Set to 0 or leave empty for unlimited',
  'voucher.max_use_per_user_placeholder':
    'Enter maximum usage times (e.g., 1, 2, 3...)',
  'voucher.start_date': 'Start Date',
  'voucher.start_date_note':
    'Date when the voucher becomes active. Voucher can only be used from this date onwards',
  'voucher.start_date_placeholder': 'Select start date',
  'voucher.end_date': 'End Date',
  'voucher.end_date_note':
    'Date when the voucher expires. Voucher will become invalid after this date. Must be after start date',
  'voucher.end_date_placeholder': 'Select end date',
  'voucher.end_date_after_start': 'End date must be after start date',

  // Cabins
  'global.cabins': 'Cabins',
  'global.size': 'Size',
  'global.qty': 'Quantity',
  'global.route': 'Route',

  // Customer Groups
  'global.discount': 'Discount',
  'global.cGroups': 'Customer groups',
  'global.group': 'Group',

  //
  'global.hops': 'Hops',
  'global.systems': 'Systems',
  'global.role': 'Role Manager',
  'global.start_time': 'Start time',
  'global.start_stop': 'Destination start',
  'global.end_stop': 'Destination end',
  'global.cabin-rates': 'Cabin rates',
  'global.title_route': 'Route',
  'global.review': 'Review',

  // Addons
  'global.addons': 'Additional services',
  'global.seat': 'Seat',
  'global.from_date': 'From',
  'global.to_date': 'Up to and including',

  'global.order_group': 'Booking group',
  'global.route_tital': 'Route',
  'global.select_customer': 'Select customer',
  'global.select_option': 'Select option',
  'global.order_status': 'Booking status',
  'global.order_cancel': 'Are you sure want to cancel this order?',
  'order.pax': 'Pax',
  'global.passport': 'Passport',
  'global.addnew': 'Add',
  'global.select_county': 'Select county',
  'global.cabin': 'Cabin',
  'global.price_type': 'Price type',
  'global.voucher': 'Voucher',
  'global.passengers': 'Passengers',
  'global.notes': 'Notes',
  'global.note': 'Note',
  'global.budget': 'Budget',
  'global.please_enter_valid_budget': 'Please enter a valid budget',
  'global.min_budget': 'Min Budget',
  'global.max_budget': 'Max Budget',
  'global.please_enter_valid_min_budget': 'Please enter a valid min budget',
  'global.please_enter_valid_max_budget': 'Please enter a valid max budget',
  'global.min_budget_must_be_lte_max_budget':
    'Min budget must not be greater than max budget',
  'global.order_id': 'Booking ID',
  'global.select_date': 'Select date',
  'global.select_hops': 'Select hop',
  'global.pay_status': 'Pay status',
  'bill.serial': 'Serial',
  'bill.billed_date': 'Payment date',
  'bill.amount': 'Amount',
  'global.method': 'Method',
  'global.payment_method': 'Payment method',
  'global.bills': 'Payment ',
  'global.ip_payment': 'IP Payment',
  'global.service_sample': 'Service sample',
  'global.notpaid': 'Not paid',
  'global.paid': 'Paid',
  'global.collect': 'Collect',
  'global.spend': 'Spend',
  'global.cash': 'Cash',
  'global.card': 'Card',
  'global.bank': 'Bank',
  'global.insurance': 'Insurance',
  'global.select_customers': 'Select customer',
  'global.select_reviewer': 'Select reviewer',
  'global.select_types': 'Select type',
  'sidebar.dept': 'AR',
  'global.total_debt_begin_period': 'Debt begin period',
  'global.total_paid_begin_period': 'Paid begin period',
  'global.total_debt_in_period': 'Debt in period',
  'global.total_paid_in_period': 'Paid in period',
  'global.total_debt_end_period': 'Total debt',

  'global.ar': 'Account receivable',
  'global.confirm': 'Confirm',
  'global.order_confirm': 'Are you sure want to confirm this order?',
  'global.bill_confirm': 'Are you sure want to approve this bill?',
  // 'global.cabin_rates': 'Cabin rates',
  'global.bookingCalendar': 'Booking calendar',
  'global.invoice': 'Invoice',
  'global.list_order_not_paid': 'List order not paid',
  'global.export_to_excel': 'Export to Excel',
  'global.report_debt_confirmation': 'Debt confirmation record',
  'global.debt': 'AR records',
  'global.bill': 'Payment',
  'global.record': 'Record',
  // report
  'global.date': 'Date',
  'global.hop': 'Hop',
  'global.addon': 'Add-on',
  'global.customer': 'Customer',
  'global.year': 'Year',

  'global.select_menu': 'Select menu',
  'global.select_role': 'Select role',

  'global.add_walk_in_customer': 'Add walk-in customer',
  'global.order_details': 'Booking details',
  'global.cabins_order': 'Cabins order',
  'global.last_30_day': 'Last 30 days',
  'global.last_7_day': 'Last 7 days',
  'global.last_month': 'Last month',
  'global.this_month': 'This month',
  'global.next_month': 'Next month',
  'global.seller': 'Seller',
  'global.send_email': 'Send email',
  'global.sale': 'Sale',
  'global.finance': 'Finance',
  'global.finance_cost_links': 'Cost Statistics',
  'global.carriages': 'Carriages',
  'global.logo': 'Logo',
  'global.content': 'Contents',
  'global.path': 'Path',
  'global.seat_allocation': 'Seat allocation',
  'global.cabinSerials': 'Cabin serials',
  'global.title_carriage': 'Title carriage',
  'global.title_cabin': 'Title cabin',
  'global.select_carriage': 'Select carriage',
  'global.order_seat': 'Booking seat',
  'global.order_seats': 'Booking seats',
  'global.Seat': 'Seat',
  'global.depart_seating': 'Depart seating',
  'global.return_seating': 'Return seating',
  'global.seating': 'Seating',
  'global.summary': 'Summary',
  'global.action': 'Action',
  'global.created_at': 'Created',
  'global.created_by': 'Created by',
  'global.roundtrip': 'Roundtrip',

  'sites.url': 'URL',
  'sites.ga_script': 'Google analytic script',
  'global.meta_data': 'Meta Data',
  'global.meta_title': 'Meta title',
  'global.meta_description': 'Meta Description',
  'global.meta_keywords': 'Meta Keywords',
  'global.before_head': 'Before Head',
  'global.before_body': 'Before Body',
  'global.layout': 'Layout',
  'global.socials': 'Socials',

  // status
  'global.all': 'All',
  'global.Pending': 'Pending',
  'global.draft': 'Draft',
  'global.withdrawn': 'Widthdrawn',
  'global.confirmed': 'Confirmed',
  'global.cancelled': 'Cancelled',
  'global.refund': 'Refund',
  'global.mark_as_paid': 'Mark as paid',

  'global.super': 'Super',
  'global.admin': 'Admin',
  'global.staff': 'Staff',
  'global.agent': 'Agent',
  'global.upgrade': 'Upgrade',
  'global.cabin_no': 'Cabin No',
  'global.carriage': 'Carriage',
  'global.cabin_type': 'Cabin Type',
  'global.view_seat': 'View Seat',
  'global.view': 'View',
  'global.view_more': 'View more',
  'global.ok': 'Ok',
  'global.seats': 'Seats',
  'global.time_period': 'Time period',
  'global.booked_seats': 'Booked seats',
  'global.allocated_seat': 'Allocated seat',
  'global.revenue': 'Revenue',
  'global.revenue_report': 'Revenue report',
  'global.cabins_performance': 'Cabins performance',
  'global.created_date': 'Created date',
  'global.depart_date': 'Depart date',
  'global.download': 'Download',
  'global.permission': 'Permission',
  'global.permissions': 'Permissions',
  'permissions.decline': 'Decline',
  'permissions.allow': 'Allow',
  'global.e_ticket': 'E-Ticket',
  'global.internal_notes': 'Internal notes',
  'global.information_customer': 'Information customer',
  'global.cgroup': 'Customer group',
  'global.order_information': 'Booking information',
  'global.accountant_email': 'Accountant email',
  'global.more': 'more',
  'global.full': 'Full',
  'global.deposited': 'Deposited',
  'global.payment_type': 'Payment type',
  'global.payment_status': 'Payment status',
  'global.contact_information': 'Contact information',
  'global.contacts': 'Contacts',
  'global.contact': 'Contact',
  'global.add_contact': 'Add contact',
  'global.office': 'Office',
  'global.select_contact': 'Select contact',
  'global.select_seller': 'Select seller',
  'global.input_group_code': 'Input code',
  'global.input_pax': 'Input pax',
  'global.input_order_notes': 'Input order notes',
  'global.input_order_internal_notes': 'Input order internal notes',
  'global.input_contact_name': 'Input contact name',
  'global.input_contact_email': 'Input contact email',
  'global.input_contact_mobile': 'Input contact mobile',
  'validate.is_not_email': 'Field is not email',
  'validate.is_not_phone_number': 'Field is not phone number',
  'order.select_other_contact': 'Other',
  'global.select_hop': 'Select a hop',
  'global.select_route': 'Select a route',
  'global.book': 'Book',
  'global.requests': 'Requests',
  'global.public_offers_title': 'Public Offers',
  'global.request': 'Request',
  'global.offers': 'Offers',
  'global.offer': 'Offer',
  'global.offer_manager': 'Offer manager',
  'global.views': 'Views',
  'global.subscribers': 'Subscriber Notification App',
  'global.subscription_order': 'Subscription Orders',
  'global.service_order': 'Service Orders',
  'global.product_order': 'Product Orders',
  'global.service': 'Services',
  'global.product_manager': 'Product Manager',
  'global.products': 'Products',
  'global.product': 'Product',
  'global.supplier': 'Suppliers',
  'global.tools': 'Tools',
  'global.landing_page': 'Landing Pages',
  'global.reports': 'Reports',
  'global.subscription_plans': 'Subscription plans',
  'global.subscription_plan_manager': 'Subscription Plan Manager',
  'global.plan_name': 'Plan Name',
  'global.monthly_price': 'Monthly Price',
  'global.semi_annual_price': 'Semi Annual Price',
  'global.annual_price': 'Annual Price',
  'global.listing_limit': 'Listing Limit',
  'global.product_limit': 'Product Limit',
  'global.active': 'Active',
  'global.inactive': 'Inactive',
  'global.user': 'User',
  'global.save_success': 'Save successfully',
  'global.save_failed': 'Save failed',
  'global.guide_number': 'Guide',
  'global.input_guide_number': 'Input guide',
  'global.input_your_password': 'Please input your password!',
  'global.input_beds': "Please input beds's name or delete this field",
  'global.input_email_or_delete':
    "Please inpt email's name or delete this field",
  'global.select_destination_start': 'Select destination start',
  'global.select_destination_end': 'Select destination end',
  'placeholder.select_hop': 'Select hop',
  'placeholder.select_addon': 'Select add-on',
  'placeholder.from': 'From',
  'placeholder.to': 'To',
  'placeholder.select_category': 'Select category',
  'placeholder.select_customer_group': 'Select customer group',
  'global.select_user': 'Select user',
  'placeholder.select_user': 'Select user',
  'global.select_permission': 'Select permission',
  'global.select_all': 'Select all',
  'global.advanced_settings_for_each_user': 'Advanced settings for each user',
  'note.reload_page': 'Need to reload the page after finishing editing',
  'global.history': 'History',
  'global.earned_history': 'Earned History',
  'global.clear': 'Clear',
  'history.from_date': 'From date',
  'history.to_date': 'To date',
  'history.week_days': 'Weekdays',
  'global.reload': 'Reload',
  'global.clear_rate_confirm': 'Are you sure want to clear this data?',
  'placeholder.booking_id_or_code': 'Booking ID or Code',
  'global.special_notes': 'Special notes',
  'placeholder.input_special_notes': 'Input special notes',
  'global.choice_a_time_period': 'Choice a time period',
  'global.not_found': 'Not found',
  'global.select_a_customer': 'Select a customer',
  'placeholder.select_customer': 'Select customer',
  'placeholder.input_notes': 'Input notes',
  'placeholder.input_description': 'Input description',
  'placeholder.input_budget': 'Optional. Amount the requester can pay',
  'placeholder.input_min_budget':
    'Optional. Minimum amount the requester can pay',
  'placeholder.input_max_budget':
    'Optional. Maximum amount the requester can pay',
  'placeholder.select_creator': 'Select creator',
  'placeholder.select_status': 'Select status',
  'placeholder.payment_from': 'Payment from',
  'placeholder.payment_to': 'Payment to',
  'global.initialization_time': 'Initialization time',
  'placeholder.input_title': 'Input title',
  'placeholder.input_reference': 'Input Reference',
  'placeholder.input_code': 'Input code',
  'placeholder.select_route': 'Select route',
  'error.quantity_is_not_the_same':
    'Quantity is not the same as ordered quantity',
  'global.addons_booking': 'Additional services',
  'error.missing_addon': 'Please select an add-on',
  'warning.not_found_carriages': 'No carriages available',
  'global.individual': 'Individual',
  'global.available': 'Available',
  'global.booking_statistics': 'Booking statistics',
  'global.total_number_of_tickets': 'Total number of tickets',
  'global.sold': 'Sold',
  'global.remaining': 'Remaining',
  'global.capacity': 'Capacity',
  'global.general_capacity': 'General capacity',
  'global.files_manager': 'Files manager',
  'global.file_manager': 'File Manager',
  'global.manager.title': 'Menu Manager',
  'global.manager.list': 'Menu List',
  'global.manager.role': 'Role Menu',
  'global.manager.user': 'User Menu',
  'error.upload_file': 'Error uploading file. Please try again.',
  'success.upload_file': 'File uploaded successfully!',
  'global.create_folder': 'Create folder',
  'global.new_folder': 'New Folder',
  'global.create_new_folder': 'Create New Folder',
  'global.upload_files': 'Upload Files',
  'global.click_or_drag_files_to_upload':
    'Click or drag files to this area to upload',
  'global.upload_hint':
    'Support for single or bulk upload. Strictly prohibited from uploading company data or other band files',
  'global.download_started': 'Download started',
  'global.failed_to_download_file': 'Failed to download file',
  'global.failed_to_preview_file': 'Failed to preview file',
  'global.copied_url_to_clipboard': 'Copied URL to clipboard',
  'global.failed_to_copy_url': 'Failed to copy URL',
  'global.failed_to_load_directory_contents':
    'Failed to load directory contents',
  'global.please_enter_folder_name': 'Please enter a folder name',
  'global.folder_created_successfully': 'Folder created successfully',
  'global.failed_to_create_folder': 'Failed to create folder',
  'global.file_uploaded_successfully': 'File uploaded successfully',
  'global.failed_to_upload_file': 'Failed to upload file',
  'global.delete_items': 'Delete Items',
  'global.confirm_delete_items':
    'Are you sure you want to delete {count} item(s)?',
  'global.items_deleted_successfully': 'Items deleted successfully',
  'global.failed_to_delete_items': 'Failed to delete items',
  'placeholder.input_folder_name': 'Input folder name',
  'global.folder_name': 'Folder name',
  'error.create_folder': 'Error create folder. Please try again.',
  'error.delete_file': 'Error delete, please try again.',
  'error.folder_name': 'Invalid folder name, please try again.',
  'error.missing_file_upload': 'Please select a file to upload.',
  'placeholder.select_date': 'Select date',
  'placeholder.input_email': 'Input email',
  'global.send': 'Send',
  'global.download_addon_booking': 'Download additional services',
  'error.send_email': 'Error send email. Please try again.',
  'global.send_email_success': 'Email sent successfully',
  'global.customer_name': 'Customer name',
  'global.seated_by': 'Seated by',
  'global.seated_date': 'Seated date',
  'sidebar.invoice': 'Invoice',
  'global.booked_from': 'Booked from',
  'global.booked_to': 'Booked to',
  'global.amount_of_money': 'Amount of money',
  'global.track': 'Track',
  'placeholder.input_track': 'Input track',
  'global.amenities': 'Amenities',
  'global.icon': 'Icon',
  'error.must_contain_least_one_value':
    'Must contain at least one information of passenger',
  'global.representative_passenger': 'Representative passenger',
  'placeholder.input_firstname': 'Input firstname',
  'placeholder.input_lastname': 'Input lastname',
  'error.missing_passenger_information':
    'Please input least one information of passenger',
  'global.refund_policy': 'Refund Policies',
  'global.refund_policies': 'Refund Policies',
  'global.cancel_fee': 'Cancel fee',
  'global.hours': 'Hours',
  'global.is_default': 'Is Default',
  'global.select_tours': 'Select a tour',
  'global.payments': 'Payments',
  'global.payment_date': 'Payment date',
  'global.payment': 'Payment',
  'global.refund_recording': 'Refund recording',
  'global.transaction': 'Transaction',
  'global.transactions': 'Transactions',
  'global.penalty_date': 'Penalty date',
  'global.today': 'Today',
  'global.penalty_status': 'Penalty status',
  'global.no_payment_yet': 'No payment yet',
  'global.tour': 'Tour',
  'placeholder.input_amount': 'Input amount',
  'success.refund_recorded': 'Refund recorded',
  'global.adults': 'Adults',
  'global.children': 'Children',
  'global.infants': 'Infants',
  'global.pickup_location': 'Pickup location',
  'global.income': 'Income',
  'global.expense': 'Expense',
  'global.pay': 'Pay',
  'global.debit': 'Debit',
  'global.amount': 'Amount',
  'global.transaction_date': 'Transaction date',
  'global.guest_payment_date': 'Transaction date',
  'global.policy_penalty_name': 'Penalty policy name',
  'global.guest_payment': 'Transaction',
  'global.guest_payment_detail': 'Transaction detail',
  'global.waiting_approve': 'Waiting approve',
  'global.created_payments': 'Created payments',
  'tour.pickup_offered': 'Pickup Offered',
  'global.pickup_offer': 'Pickup offer',
  'global.both': 'Both',
  'global.free_cancel': 'Free cancel',
  'global.penalty': 'Penalty',
  'global.cancel_booking': 'Cancel booking',
  'global.pickup_time': 'Pickup time',
  'global.create_transaction': 'Create transaction',
  'global.depart_value': 'Depart value',
  'global.penalty_amount': 'Penalty amount',
  'global.add_pickup': 'Add pickup',
  'global.select_meeting_type': 'Select meeting point type',
  'global.book_tour': 'Book tour: ',
  'global.endWorkingTime': 'End working time',

  //payment method
  'global.merchant_id': 'Merchant Id',
  'global.secret_key': 'Secret key',
  'global.device_id': 'Device Id',

  //
  'global.send_link_payment': 'Send Link Payment',
  'global.filter_params': 'Filters',
  'global.category_id': 'Category',
  'global.destination_id': 'Destination',

  'global.market': 'Market',
  'global.flat': 'Flat',
  'global.commission_amount': 'Commission amount',

  'global.waiting': 'Waiting',

  'global.select_operators': 'Select Operators',
  'order.supplier_status': 'Supplier Status',
  'global.free_cancel_date': 'Free Cancel Date',
  'global.time_start': 'Time Start',
  'global.supplier_total': 'Supplier Total',
  'global.edit_pickup': 'Edit Pickup',
  'global.edit_passengers': 'Edit Passengers',
  'global.drop_off': 'Drop off',
  'global.driver_notes': 'Driver_notes',
  'global.policies': 'Policies',
  'global.cancellation_policy_summary': 'Cancellation',
  'global.free_cancellation': 'Free Cancellation',
  'global.service_fee': 'Service fee',
  'global.ordering': 'Ordering',
  'global.price_cron': 'Price cron',
  'global.unit': 'Unit',

  'global.passenger': 'Passenger',

  'global.subtotal': 'Subtotal',
  'global.refund_amount': 'Refund amount',
  'global.cancellation_date': 'Cancellation date',
  'global.cancellation_fee': 'Cancellation fee',
  'global.cache_reset': 'Cache reset',
  'global.additional_info': 'Additional info',
  'global.driver': 'Driver',

  'global.select_type': 'Select Type',
  'global.brand': 'Brand',
  'global.brand_manager': 'Brand Manager',

  // crm
  'global.crm': 'CRM',
  'global.segments': 'Segments',
  'global.templates': 'Email Templates',
  'global.app': 'App',
  'global.select_app': 'Select App',
  'global.campaigns': 'Campaigns',
  'global.click_conversion': 'Click and Conversions',
  'global.phone_code': 'Phone code',
  'global.action_date': 'Action date',
  'global.date_of_birth': 'Date of Birth',
  'global.lead_status': 'Lead status',
  'global.new': 'New',
  'global.open': 'Open',
  'global.in_progress': 'In progress',
  'global.unqualified': 'Unqualified',
  'global.attempted_to_contact': 'Attempted to contact',
  'global.connected': 'Connected',
  'global.bad_timing': 'Bad timing',
  'global.subscribed': 'Subscribed',
  'global.unsubscribed': 'Unsubscribed',
  'global.owner': 'Owner',
  'global.subject': 'Subject',
  'global.email_attachments': 'Attachments',
  'global.email_body_preview': 'Preview',
  'global.email_body_edit': 'Edit content',
  'global.email_attachments_hint': 'Upload from your computer (max 20MB: images, PDF, Word, Excel, PowerPoint) or paste an existing link. Apps that read this template get these links to attach when sending.',
  'global.email_attachment_name': 'File name',
  'global.email_attachment_upload': 'Upload file',
  'global.email_attachment_view': 'View file',
  'global.email_attachment_add_link': 'Add by link',
  'global.email_attachment_upload_failed': 'Upload failed: {name}',
  'global.email_attachment_too_large': '{name} is larger than 20MB',
  'global.email_attachment_link_invalid': 'Link must start with http:// or https://',
  'global.once': 'Once',
  'global.daily': 'Daily',
  'global.repeat': 'Repeat',
  'global.audiences': 'Audiences',
  'global.analytics': 'Analytics',
  'global.opened': 'Opened',
  'global.schedule_date': 'Schedule date',
  'global.send_now': 'Send now',
  'global.campaign_key': 'Campaign key',
  'global.segment': 'Segment',
  'global.template': 'Template',
  'global.links': 'Links',
  'global.conditions': 'Conditions',
  'global.is': 'Is',
  'global.is_not': 'Is not',
  'global.contain': 'Contain',
  'global.not_contain': 'Not contain',
  'global.start_with': 'Start with',
  'global.end_with': 'End with',
  'global.send_index': 'Send IndexNow',
  'global.send_success': 'Send success',
  'global.source': 'Source',
  'global.apply': 'Apply',
  'global.sent': 'Sent',
  'global.not_send': 'Not sent',
  'global.sent_date': 'Sent date',
  'global.recipients': 'Recipients',
  'global.campaign_status': 'Campaign status',
  'global.running': 'Running',
  'global.stopped': 'Stopped',
  'global.create_segment': 'Create segment',
  'global.clicked': 'Clicked',
  'global.clicks': 'Clicks',
  'global.start': 'Start',
  'global.stop': 'Stop',
  'global.completed': 'Completed',
  'global.not_open': 'Not open',
  'global.not_click': 'Not click',
  'global.promotions': 'Promotions',
  'global.promotion': 'Promotion',
  'global.used_from': 'Used from',
  'global.used_to': 'Used to',
  'global.used_at': 'Used at',
  'global.discounts': 'Discounts',
  'placeholder.select_group': 'Select Group',
  'global.customer_group': 'Customer Group',
  'global.booked_at_from': 'Booked from',
  'global.booked_at_to': 'Booked to',
  'placeholder.booked_at_from': 'Booked from',
  'placeholder.booked_at_to': 'Booked to',
  'placeholder.used_at_from': 'Used from',
  'placeholder.used_at_to': 'Used to',
  'global.booked_at': 'Booked at',
  'global.app_id': 'App ID',
  'global.body': 'Body',
  'global.role_management': 'Role Management',
  'global.role_name': 'Name',
  'global.role_description': 'Description',
  'global.role_key': 'Key',
  'global.role_management_app': 'App',
  'global.role_management_config': 'Config',

  'global.landing_page_title': 'Landing Page',
  'global.landing_page_full_name': 'Full Name',
  'global.landing_page_email': 'Email',
  'global.affcampaign_management_campaign': 'Campaign',
  'global.affcampaign_management_campaign_type': 'Camp Type',
  'global.affcampaign_campaign_type_duration': 'Duration',
  'global.affcampaign_publisher_join': 'Publisher',

  'global.campaign_user': 'Publishers',
  'global.earned': 'Earned',
  'global.affiliate_code': 'Affiliate Code',
  'global.campaign_user_management': 'Publishers Management',
  'global.conversion_management': 'Conversion Management',
  'global.referral_management': 'Referral Management',
  'global.click_management': 'Clicks Management',
  'global.http_referrer': 'HTTP Referrer',
  'global.campaign_management': 'Campaign Management',
  'global.campaign_product_commission_management':
    'Campaign Product Commission Management',
  'global.joined_at': 'Joined At',
  'global.referral_code': 'Referral Code',
  'global.ip_address': 'IP Address',
  'global.ip_address_payment': 'IP Address Payment',
  'global.user_agent': 'User Agent',
  'global.referred_at': 'Referred At',
  'global.commission_earned': 'Commission Earned',
  'global.converted_at': 'Converted At',
  'global.affcampaign_management_commission_type': 'Commission Type',
  'global.affcampaign_management_commission_value': 'Commission Value',
  'global.affcampaign_management_commission': 'Commission',
  'global.commissionValueType': 'Comm Value Type',
  'global.affiliate': 'Affiliate',
  'global.affcampaign': 'Campaigns',
  'global.campaignUser': 'Publishers',
  'global.conversion': 'Conversions',
  'global.conversion_type': 'Conversion Type',
  'global.campaign_product_commission': 'Campaign Product Commissions',
  'global.referral': 'Referrals',
  'global.referrer': 'Referrer',
  'global.landing_page_area': 'Area',
  'global.landing_page_work_preference': 'Work Preference',
  'global.landing_page_file': 'File',
  'global.menu_sidebar_seller': 'Sellers',
  'global.seller_management': 'Sellers',
  'global.seller_management_profession': 'Profession',
  'global.seller_management_about': 'About',
  'global.seller_management_banner': 'Banner',
  'global.seller_management_experiences': 'Experiences',
  'global.seller_management_educations': 'Educations',
  'global.seller_management_addresses': 'Addresses',
  'global.seller_management_bank_accounts': 'Bank accounts',
  'global.seller_management_skills': 'Skills',
  'global.seller_management_certificates': 'Certificates',
  'global.seller_management_IsOrgOwner': 'IsOrgOwner',
  'global.seller_management_user_id': 'UserID',
  'global.seller_management_user_name': 'User',
  'global.seller_management_Organization_id': 'Organization',
  'global.seller_management_Organization_name': 'Organization',
  'global.seller_form_label_seller': 'Seller',
  'global.seller_form_label_user': 'User',
  'global.seller_form_label_sale_user': 'Sale user',
  'global.seller_form_label_organization': 'Organization',

  'global.seller_form_label_company_name': 'Company name',
  'global.seller_form_label_company_address': 'Company address',
  'global.seller_form_label_job_position': 'Job position',
  'global.seller_form_label_from_year': 'From year',
  'global.seller_form_label_to_year': 'To year',

  'global.seller_form_label_address': 'Address',
  'global.seller_form_label_major': 'Major',
  'global.seller_form_label_school_name': 'School name',

  'global.seller_form_label_street_address': 'Street address',
  'global.seller_form_label_apartment_unit': 'Apartment/Unit',
  'global.seller_form_label_city': 'City',
  'global.seller_form_label_state_province': 'State province',
  'global.seller_form_label_country': 'Country',
  'global.seller_form_primary_address': 'Main address (shown on the website)',
  'global.seller_form_country_unlinked': 'Not linked to a country - edit and pick one',
  'global.seller_form_label_latitude': 'Latitude',
  'global.seller_form_label_longitude': 'Longitude',

  'global.seller_form_label_card_type': 'Card type',
  'global.seller_form_label_last_4_digits': 'Last 4 digits',
  'global.seller_form_label_expiry_date': 'Expiry date',
  'global.seller_form_label_card_type': 'Card type',
  'global.seller_form_label_last_4_digits': 'Last 4 digits',
  'global.seller_form_label_expiry_date': 'Expiry date',
  'global.filter_by_seller': 'Filter by seller',

  'global.seller_form_label_certificate_name': 'Certificate name',
  'global.seller_form_label_location': 'Location',
  'global.seller_form_label_issued_date': 'Issued date',
  'global.seller_form_label_issuer': 'Issuer',
  'global.seller_form_label_image_url': 'Image url',

  'global.organization': 'Organizations',
  'global.organization_manager_title': 'Organizations',
  'global.organization_manger_table_name': 'Name',
  'global.organization_manger_table_description': 'Description',
  'global.organization_manger_table_logo': 'Logo',
  'global.organization_manger_table_website': 'Website',
  'global.organization_manger_table_contact_email': 'Contact email',
  'global.organization_manger_table_contact_phone': 'Contact phone',
  'global.organization_manger_table_address': 'Address',
  'global.organization_manger_table_social_media': 'Social media',
  'global.organization_manger_table_business_hours': 'Business hours',

  'global.social_facebook': 'Facebook',
  'global.social_twitter': 'Twitter',
  'global.social_linkedin': 'LinkedIn',

  'global.organization_form_label_street_address': 'Street address',
  'global.organization_form_label_city': 'City',
  'global.organization_form_label_country': 'Country',

  'global.organization_form_label_day': 'Day',
  'global.organization_form_label_open_time': 'Open time',
  'global.organization_form_label_close_time': 'Close time',

  'global.link': 'link',
  'global.invalid_phone': 'Invalid phone number.',
  'global.invalid_email': 'Invalid email format.',
  'global.search_by_title_or_content': 'Search by title or content...',
  'global.filter_by_category': 'Filter by category',
  'global.filter_by_status': 'Filter by status',
  'global.product_saved': 'Product saved!',
  'global.failed_to_save_product': 'Failed to save product.',
  'global.edit_product': 'Edit Product',
  'global.add_product': 'Add Product',
  'global.please_input_product_name': 'Please input the product name!',
  'global.name_max_255': 'Name cannot be longer than 255 characters!',
  'global.please_input_sku': 'Please input the SKU!',
  'global.sku_max_50': 'SKU cannot be longer than 50 characters!',
  'global.please_select_category': 'Please select a category!',
  'global.select_category': 'Select category',
  'global.brand': 'Brand',
  'global.select_brand': 'Select a brand',
  'global.enter_new_brand_name': 'Enter a new brand name',
  'global.please_select_brand': 'Please select a brand!',
  'global.please_enter_new_brand_name': 'Please enter a new brand name!',
  'global.seller_management_user_name': 'User',
  'global.please_select_user': 'Please select a user!',
  'global.select_user': 'Select user',
  'global.stock_quantity': 'Stock Quantity',
  'global.please_input_stock_quantity': 'Please input the stock quantity!',
  'global.stock_quantity_non_negative': 'Stock quantity cannot be negative!',
  'global.manufacture_date': 'Manufacture Date',
  'global.please_select_manufacture_date': 'Please select manufacture date!',
  'global.expiry_date': 'Expiry Date',
  'global.expiry_after_manufacture':
    'Expiry date must be after manufacture date!',
  'global.country_of_origin': 'Country of Origin',
  'global.please_input_country_of_origin': 'Please input country of origin!',
  'global.license_no': 'License No.',
  'global.please_input_license_no': 'Please input license number!',
  'global.status': 'Status',
  'global.please_select_status': 'Please select status!',
  'global.product_image': 'Product Image',
  'global.license_file': 'License File',
  'global.upload': 'Upload',
  'global.pricing_tiers': 'Pricing Tiers',
  'global.missing_price': 'Missing price',
  'global.price_non_negative': 'Price cannot be negative!',
  'global.price': 'Price',
  'global.missing_unit': 'Missing unit',
  'global.unit': 'Unit',
  'global.description': 'Description',
  'global.add_new_price': 'Add new price',
  'global.failed_to_load_users': 'Failed to load users.',
  'global.request_manager': 'Request Manager',
  'global.search_by_description': 'Search by description...',
  'global.na': 'N/A',
  'global.user': 'User',
  'global.assigned_to': 'Assigned To',
  'global.notes': 'Notes',
  'global.id': 'ID',
  'global.failed_to_load_categories': 'Failed to load categories.',
  'global.request_updated_success': 'Request updated successfully!',
  'global.request_created_success': 'Request created successfully!',
  'global.failed_to_save_request': 'Failed to save request.',
  'global.edit_request': 'Edit Request',
  'global.add_request': 'Add Request',
  'global.please_enter_description': 'Please enter description!',
  'global.please_select_status': 'Please select status!',
  'global.select_status': 'Select status',
  'global.pending': 'Pending',
  'global.done': 'Done',
  'global.approved': 'Approved',
  'global.please_select_category': 'Please select category!',
  'global.select_category': 'Select category',
  'global.requester': 'Requester',
  'global.please_select_requester': 'Please select requester!',
  'global.select_requester': 'Select requester',
  'global.assignee': 'Assignee',
  'global.please_select_assignee': 'Please select assignee!',
  'global.select_assignee': 'Select assignee',
  'global.attachments': 'Attachments',
  'global.please_enter_attachments': 'Please enter attachments!',
  'global.choose_file': 'Choose File',
  'global.please_enter_notes': 'Please enter notes!',
  'global.subscriber_manager': 'Subscriber Notification App Manager',
  'global.failed_to_fetch_subscribers': 'Failed to fetch subscribers!',
  'global.delete_subscriber_success': 'Delete subscriber successfully!',
  'global.delete_subscriber_failed': 'Delete subscriber failed!',
  'global.user_id': 'User ID',
  'global.device_id': 'Device ID',
  'global.os': 'OS',
  'global.search_by_device_id': 'Search by device ID...',
  'global.subscription_plan_manager': 'Subscription Plan Manager',
  'global.edit_subscription_plan': 'Edit Subscription Plan',
  'global.add_subscription_plan': 'Add Subscription Plan',
  'global.plan_name': 'Plan Name',
  'global.please_input_plan_name': 'Please input plan name!',
  'global.monthly_price': 'Monthly Price',
  'global.please_input_monthly_price': 'Please input monthly price!',
  'global.semi_annual_price': 'Semi-Annual Price',
  'global.please_input_semi_annual_price': 'Please input semi-annual price!',
  'global.annual_price': 'Annual Price',
  'global.please_input_annual_price': 'Please input annual price!',
  'global.listing_limit': 'Listing Limit',
  'global.please_input_listing_limit': 'Please input listing limit!',
  'global.product_limit': 'Product Limit',
  'global.please_input_product_limit': 'Please input product limit!',
  'global.is_active': 'Is Active',
  'global.is_active_required': 'Please select active status!',
  'global.iap_enabled': 'IAP Enabled',
  'global.apple_product_id': 'Apple Product ID',
  'global.google_product_id': 'Google Product ID',
  'global.stripe_product_id': 'Stripe Product ID',
  'global.stripe_price_id': 'Stripe Price ID',
  'global.please_input_apple_product_id': 'Please input Apple Product ID!',
  'global.please_input_google_product_id': 'Please input Google Product ID!',
  'global.please_input_stripe_product_id': 'Please input Stripe Product ID!',
  'global.please_input_stripe_price_id': 'Please input Stripe Price ID!',
  'global.delete_failed': 'Delete failed!',
  'global.failed_to_fetch_offers': 'Failed to fetch offers!',
  'global.please_input_title': 'Please input the title!',
  'global.please_input_message': 'Please input the message!',
  'global.please_select_recipients': 'Please select at least one recipient!',
  'global.select_recipients': 'Select recipients',
  'global.failed_to_fetch_sellers': 'Failed to fetch sellers!',
  'global.failed_to_fetch_customers': 'Failed to fetch customers!',
  'global.accepted': 'Accepted',
  'global.rejected': 'Rejected',
  'global.max_30_chars': 'Maximum 30 characters',
  'global.expired': 'Expired',
  'global.please_upload_at_least_one_image':
    'Please upload at least one product image!',
  'global.please_upload_license_file':
    'Please upload the product license file!',
  'global.please_input_at_least_one_price':
    'Please input at least one price tier!',
  'global.email_already_exists': 'Email already exists!',
  'global.mobile_already_exists': 'Phone number already exists!',
  'global.click_to_copy': 'Click to copy',
  'global.website_invalid': 'Website url is invalid!',
  'global.date_not_in_past': 'Date cannot be in the past!',
  'global.end_date_after_start_date': 'End date must be after start date!',
  'global.required-referals': 'Please select a referal',
  'global.required-user': 'Please select an user',
  'global.required-amount': 'Please enter amount',
  'global.required-commission-earned': 'Please enter commission earned',
  'global.required-commission-type': 'Please select a commission type',
  'global.required-converted-at': 'Please select a time ',
  'global.seller_management_shop-name': 'Shop Name',
  'global.created_at': 'Created',
  'global.type': 'Type',
  'global.card_number_last4': 'Card Number',
  'global.cardholder_name': 'Cardholder Name',
  'global.card_brand': 'Card Brand',
  'global.card_exp_month': 'Exp Month',
  'global.card_exp_year': 'Exp Year',
  'global.is_verified': 'Verified',
  'global.default': 'Default',
  'global.link': 'link',
  'global.invalid_phone': 'Invalid phone number.',
  'global.invalid_email': 'Invalid email format.',
  'global.search_by_title_or_content': 'Search by title or content...',
  'global.filter_by_category': 'Filter by category',
  'global.filter_by_status': 'Filter by status',
  'global.product_saved': 'Product saved!',
  'global.failed_to_save_product': 'Failed to save product.',
  'global.edit_product': 'Edit Product',
  'global.add_product': 'Add Product',
  'global.please_input_product_name': 'Please input the product name!',
  'global.name_max_255': 'Name cannot be longer than 255 characters!',
  'global.please_input_sku': 'Please input the SKU!',
  'global.sku_max_50': 'SKU cannot be longer than 50 characters!',
  'global.please_select_category': 'Please select a category!',
  'global.select_category': 'Select category',
  'global.brand': 'Brand',
  'global.select_brand': 'Select a brand',
  'global.enter_new_brand_name': 'Enter a new brand name',
  'global.please_select_brand': 'Please select a brand!',
  'global.please_enter_new_brand_name': 'Please enter a new brand name!',
  'global.seller_management_user_name': 'User',
  'global.please_select_user': 'Please select a user!',
  'global.select_user': 'Select user',
  'global.stock_quantity': 'Stock Quantity',
  'global.please_input_stock_quantity': 'Please input the stock quantity!',
  'global.stock_quantity_non_negative': 'Stock quantity cannot be negative!',
  'global.manufacture_date': 'Manufacture Date',
  'global.please_select_manufacture_date': 'Please select manufacture date!',
  'global.expiry_date': 'Expiry Date',
  'global.expiry_after_manufacture':
    'Expiry date must be after manufacture date!',
  'global.please_input_country_of_origin': 'Please input country of origin!',
  'global.license_no': 'License No.',
  'global.please_input_license_no': 'Please input license number!',
  'global.status': 'Status',
  'global.please_select_status': 'Please select status!',
  'global.product_image': 'Product Image',
  'global.license_file': 'License File',
  'global.upload': 'Upload',
  'global.pricing_tiers': 'Pricing Tiers',
  'global.missing_price': 'Missing price',
  'global.price_non_negative': 'Price cannot be negative!',
  'global.price': 'Price',
  'global.missing_unit': 'Missing unit',
  'global.unit': 'Unit',
  'global.description': 'Description',
  'global.add_new_price': 'Add new price',
  'global.failed_to_load_users': 'Failed to load users.',
  'global.request_manager': 'Request Manager',
  'global.search_by_description': 'Search by description...',
  'global.na': 'N/A',
  'global.user': 'User',
  'global.assigned_to': 'Assigned To',
  'global.notes': 'Notes',
  'global.id': 'ID',
  'global.failed_to_load_categories': 'Failed to load categories.',
  'global.request_updated_success': 'Request updated successfully!',
  'global.request_created_success': 'Request created successfully!',
  'global.failed_to_save_request': 'Failed to save request.',
  'global.failed_to_save_request': 'Failed to save request.',
  'global.edit_request': 'Edit Request',
  'global.add_request': 'Add Request',
  'global.please_enter_description': 'Please enter description!',
  'global.please_select_status': 'Please select status!',
  'global.select_status': 'Select status',
  'global.pending': 'Pending',
  'global.done': 'Done',
  'global.approved': 'Approved',
  'global.please_select_category': 'Please select category!',
  'global.select_category': 'Select category',
  'global.requester': 'Requester',
  'global.please_select_requester': 'Please select requester!',
  'global.select_requester': 'Select requester',
  'global.assignee': 'Assignee',
  'global.please_select_assignee': 'Please select assignee!',
  'global.select_assignee': 'Select assignee',
  'global.attachments': 'Attachments',
  'global.please_enter_attachments': 'Please enter attachments!',
  'global.choose_file': 'Choose File',
  'global.please_enter_notes': 'Please enter notes!',
  'global.subscriber_manager': 'Subscriber Notification App Manager',
  'global.failed_to_fetch_subscribers': 'Failed to fetch subscribers!',
  'global.delete_subscriber_success': 'Delete subscriber successfully!',
  'global.delete_subscriber_failed': 'Delete subscriber failed!',
  'global.user_id': 'User ID',
  'global.device_id': 'Device ID',
  'global.os': 'OS',
  'global.order_no': 'Order No',
  'global.transaction_id': 'Transaction Id',
  'global.search_by_device_id': 'Search by device ID...',
  'global.subscription_plan_manager': 'Subscription Plan Manager',
  'global.edit_subscription_plan': 'Edit Subscription Plan',
  'global.add_subscription_plan': 'Add Subscription Plan',
  'global.plan_name': 'Plan Name',
  'global.please_input_plan_name': 'Please input plan name!',
  'global.monthly_price': 'Monthly Price',
  'global.please_input_monthly_price': 'Please input monthly price!',
  'global.semi_annual_price': 'Semi-Annual Price',
  'global.please_input_semi_annual_price': 'Please input semi-annual price!',
  'global.annual_price': 'Annual Price',
  'global.please_input_annual_price': 'Please input annual price!',
  'global.listing_limit': 'Listing Limit',
  'global.please_input_listing_limit': 'Please input listing limit!',
  'global.product_limit': 'Product Limit',
  'global.please_input_product_limit': 'Please input product limit!',
  'global.is_active': 'Is Active',
  'global.is_active_required': 'Please select active status!',
  'global.delete_failed': 'Delete failed!',
  'global.failed_to_fetch_offers': 'Failed to fetch offers!',
  'global.please_input_title': 'Please input the title!',
  'global.please_input_message': 'Please input the message!',
  'global.please_select_recipients': 'Please select at least one recipient!',
  'global.select_recipients': 'Select recipients',
  'global.failed_to_fetch_sellers': 'Failed to fetch sellers!',
  'global.failed_to_fetch_customers': 'Failed to fetch customers!',
  'global.accepted': 'Accepted',
  'global.rejected': 'Rejected',
  'global.expired': 'Expired',
  'global.please_upload_at_least_one_image':
    'Please upload at least one product image!',
  'global.please_upload_license_file':
    'Please upload the product license file!',
  'global.please_input_at_least_one_price':
    'Please input at least one price tier!',
  'global.email_already_exists': 'Email already exists!',
  'global.mobile_already_exists': 'Phone number already exists!',
  'global.website_invalid': 'Website url is invalid!',
  'global.date_not_in_past': 'Date cannot be in the past!',
  'global.end_date_after_start_date': 'End date must be after start date!',
  'requestSeller.title': 'Seller Invitations',
  'requestSeller.create': 'Create',
  'requestSeller.delete': 'Delete',
  'requestSeller.delete_confirm': 'Are you sure to delete?',
  'requestSeller.delete_success': 'Delete successful!',
  'requestSeller.delete_fail': 'Delete failed!',
  'requestSeller.load_fail': 'Failed to load seller invitations!',
  'requestSeller.id': 'ID',
  'requestSeller.request': 'Request',
  'requestSeller.seller': 'Seller',
  'requestSeller.status': 'Status',
  'requestSeller.message': 'Message',
  'requestSeller.expires_at': 'Expires At',
  'requestSeller.action': 'Action',
  'global.send_expert': 'Send to expert',
  'global.send_request': 'Send Request',
  'global.send': 'Send',
  'requestSeller.expires_at_required': 'Please select expiration date!',
  'requestSeller.select_seller_required': 'Please select at least one seller!',
  'global.select_seller': 'Select seller',
  'global.send_invite': 'Sent',
  'global.sku_already_exists':
    'The SKU already exists. Please use a different one.',
  'global.service_fee': 'Service Fee',
  'global.commission_fee': 'Commission Fee',
  'global.withdrawal_status': 'Withdrawal Status',
  'global.cancel_status': 'Cancel Status',
  'global.completed_date': 'Completed Date',
  'global.refund_amount': 'Refund Amount',
  'global.refund_notes': 'Refund Notes',
  'global.refund_date': 'Refund Date',
  'global.quantity': 'Quantity',
  'global.product_snapshot_name': 'Product Name',
  'global.order_product_status': 'Order status',
  'placeholder.select_product': 'Select product',
  'placeholder.select_shop': 'Select shop',
  'placeholder.input_service_fee': 'Enter service fee',
  'placeholder.input_commission_fee': 'Enter commission fee',
  'placeholder.input_method': 'Enter method',
  'placeholder.input_type': 'Enter type',
  'placeholder.select_order_status': 'Select order status',
  'placeholder.select_pay_status': 'Select pay status',
  'global.edit_product_order_success': 'Edit product order successfully!',
  'global.add_product_order_success': 'Create product order successfully!',
  'global.closed': 'Closed',
  'global.spam': 'Spam',
  'global.not_spam': 'No',
  'global.outstanding': 'Outstanding',
  'global.outstanding_only': 'Outstanding only',
  'global.not_outstanding': 'Not outstanding',
  'global.brand.duplicate_name':
    'Brand name already exists, please enter another brand name.',
  'global.search_by_email': 'Search by email...',
  'global.seller': 'Seller',
  'global.please_select_country': 'Please select a country',
  'global.select_expert': 'Select expert',
  'global.search_by_seller': 'Search by seller',
  'global.search_by_customer': 'Search by customer',
  'global.create_success': 'Create succesfully!',
  'global.update_success': 'Update succesfully!',
  'global.request_required': 'Request is required',
  'global.service_required': 'Service is required',
  'global.select_request': 'Select request',
  'global.select_service': 'Select service',
  'global.title_required': 'Title is required',
  'global.description_required': 'Description is required',
  'global.seller_required': 'Seller is required',
  'global.customer_required': 'Customer is required',
  'global.price_required': 'Price is required',
  'global.status_required': 'Status is required',
  'global.type_required': 'Type is required',
  'global.description_max_1000': 'Description must be at most 1000 characters',
  'global.seller_form_label_year_of_certification': 'Certification Year',
  'global.seller_form_label_link_certificate': 'Certificate Link',
  'global.seller_form_label_image': 'Certificate Image',
  'global.seller_duplicate_user_title': 'User already has seller profile',
  'global.seller_duplicate_user_message':
    'This user already has a seller profile. Please select a different user and try again.',
  'global.user_revenue': 'User Revenue',
  'global.customer_receivables': 'Customer Receivables',
  'global.order_item_id': 'Order Item',
  'global.select_order_item': 'Select Order Item',
  'global.gross_amount': 'Gross Amount',
  'global.platform_fee': 'Platform Fee',
  'global.net_amount': 'Net Amount',
  'global.release_at': 'Release At',
  'global.filter_by_user': 'Filter by User',
  'global.filter_by_type': 'Filter by Type',
  'global.filter_by_status': 'Filter by Status',
  'global.shipping_status': 'Shipping status',
  'global.placeholder_shipping_status': 'Select shipping status',
  'global.add_user_revenue': 'Add User Revenue',
  'global.edit_user_revenue': 'Edit User Revenue',
  'global.metadata_amount': 'Metadata Amount',
  'global.metadata_type': 'Metadata Type',
  'global.metadata_offer_id': 'Metadata Offer',
  'global.metadata_order_no': 'Metadata Order No',
  'global.metadata_customer_id': 'Metadata Customer ID',
  'global.system_log': 'System Log',
  'global.enter_skills': 'Enter skills',
  'global.select_order': 'Select order',
  'global.app-settings': 'App Settings',
  'global.namespace': 'Namespace',
  'global.platform': 'Platform',
  'global.value_json': 'Value (JSON)',
  'global.version': 'Version',
  'global.created_by': 'Create by',
  'global.updated_by': 'Update by',
  'global.deleted_at': 'Deleted at',
  'global.search_keyword': 'Search keyword',
  'global.filter_by_namespace': 'Search by namespace',
  'global.filter_by_platform': 'Search by platform',
  'global.no_slug': 'No slug',
  'global.no_category_slug': 'No category slug',
  'global.sb_com_product': 'Seller commission on product (%)',
  'global.sb_com_product_required': 'Seller commission on product is required',
  'global.sb_com_service': 'Seller commission on service (%)',
  'global.sb_com_service_required': 'Seller commission on service is required',
  'global.sb_com_service_user': 'Buyer commission on service (%)',
  'global.sb_com_service_user_required':
    'Buyer commission on service is required',
  'global.released_payment_days': 'Withdrawal available after X days',
  'global.released_payment_days_required': 'Withdrawal period is required',
  'global.withdrawal': 'Withdrawal',
  'global.transaction_ref': 'Transaction Reference',
  'global.processed_at': 'Processed At',
  'global.add-app-settings': 'Add App Settings',
  'global.edit-app-settings': 'Edit App Settings',
  'global.profile_score': 'Profile Score',
  'global.please_select':
    ' Please select a category and experts to send your request',
  'global.seller_experencies_form_label_start_year': 'Start year',
  'global.seller_experencies_form_label_end_year': 'End year',
  'global.select_publisher': 'Select publisher',
  'global.processed_at': 'Processed at',
  'global.transaction_ref': 'Transaction ref',
  'global.requested_at': 'Requested at',
  'global.file_manager': 'File Manager',
  'global.target_link': 'Target Link',
  'global.bank_name': 'Bank name',
  'global.account_number': 'Account number',
  'global.auto_request_matching': 'Auto Request Matching',
  'global.failed_to_search_users': 'Failed to search users',
  'global.failed_to_fetch_countries': 'Failed to fetch countries',
  'global.seller_management_shop-name_and_subscription':
    'Shop Name & Subscription',
  'global.seller_management_service_count': 'Services',

  // Additional keys for categories and other components
  'global.notification': 'Notification',
  'global.category_not_found': 'Category not found or has no children',
  'global.category_tree': 'Category Tree',
  'global.error': 'Error',
  'global.cannot_load_category_tree': 'Cannot load category tree',
  'global.avatar': 'Avatar',
  'global.domain': 'Domain',
  'global.theme': 'Theme',
  'global.mobile': 'Mobile',
  'global.items': 'Items',
  'global.hotline': 'Hotline',
  'global.keyword': 'Keyword',
  'global.slug_already_exists': 'Slug already exists',
  'global.slug_already_exists_message':
    'This slug is already used by another post. Please choose a different slug.',
  'global.slug_auto_generate_tooltip':
    'Slug is automatically generated from the question, but you can edit it if needed',
  'global.slug_auto_generate_placeholder':
    'Slug will be automatically generated from the question',
  'global.notification_channels': 'Notification Channels',
  'global.notification_all': 'All Notifications',
  'global.search_by_name_or_type': 'Search by name or type...',
  'global.filter_by_type': 'Filter by type',
  'global.push_notification': 'Push Notification',
  'global.email': 'Email',
  'global.sms': 'SMS',
  'global.in_app': 'In App',
  'global.settings': 'settings',
  'global.notification_channel_deleted_successfully':
    'Notification channel deleted successfully!',
  'global.failed_to_delete_notification_channel':
    'Failed to delete notification channel.',
  'global.failed_to_load_notification_channels':
    'Failed to load notification channels',
  'global.notification_config_manager': 'Notification Config Manager',
  'global.topic': 'Topic',
  'global.channels': 'Channels',
  'global.push_template': 'Push Template',
  'global.in_app_template': 'In App Template',
  'global.email_template_key': 'Email Template Key',
  'global.enabled': 'Enabled',
  'global.disabled': 'Disabled',
  'global.notification_config_deleted_successfully':
    'Notification config deleted successfully!',
  'global.failed_to_delete_notification_config':
    'Failed to delete notification config.',
  'global.failed_to_toggle_notification_config':
    'Failed to toggle notification config.',
  'global.notification_config_enabled_successfully':
    'Notification config enabled successfully!',
  'global.notification_config_disabled_successfully':
    'Notification config disabled successfully!',
  'global.notification_config_toggle_failed':
    'Notification config toggle failed!',
  'global.notification_config_toggle_success':
    'Notification config toggle success!',
  'global.notification_config_toggle_failed':
    'Notification config toggle failed!',
  'global.action_url': 'Action url',
  'global.notification_config': 'Notification Config',
  'global.withdrawal_min_amount': 'Withdrawal minimum amount',
  'global.withdrawal_min_amount_required':
    'Withdrawal minimum amount is required',
  'global.warning': 'Warning',
  'global.withdrawal_min_amount_warning':
    'Current withdrawal amount ({currentAmount}) is less than minimum required ({minAmount}). Cannot approve this withdrawal.',
  'global.withdrawal_min_amount_error':
    'Cannot approve withdrawal. Minimum amount required is {minAmount}. Current amount is {currentAmount}.',
  'global.force_update_version': 'Force update version',
  'global.soft_update_version': 'Soft update version',
  'global.latest_version': 'Latest version',
  'global.ios_store_url': 'iOS App Store URL',
  'global.android_store_url': 'Android Play Store URL',
  'global.version_check_namespace_hint':
    'Use namespace version_check or version_check.{app-flavor} (e.g. version_check.strongbody-ai). Platform must be App.',
  'global.app_setting_type': 'Config type',
  'global.app_setting_type_system': 'System',
  'global.app_setting_type_version_check': 'Version check (mobile app)',
  'global.app_setting_namespace_preset': 'Namespace preset',
  'global.value_of_1_point': 'Value of 1 Point($)',
  'notification_all.modal.view_title': 'View Notification',
  'notification_all.modal.add_title': 'Send New Notification',
  'notification_all.select_users': 'Select Users',
  'notification_all.select_users_placeholder':
    'Search by name or email',
  'notification_all.select_users_required': 'Please select at least one user',
  'notification_all.channels': 'Notification Channels',
  'notification_all.template_key': 'Template Key',
  'notification_all.schedule_time': 'Schedule Time',
  'notification_all.schedule_time_placeholder':
    'Select schedule time (optional)',
  'notification_all.send_to_active_only': 'Send To Active Only',
  'notification_all.last_login_range': 'Last Login Date Range',
  'notification_all.last_login_range_tooltip': 'Filter users who logged in between these dates (optional)',
  'notification_all.last_login_from': 'From Date',
  'notification_all.last_login_to': 'To Date',
  'notification_all.select_all_filtered': 'Select All {count} Filtered Users',
  'notification_all.deselect_all_filtered': 'Deselect All {count} Users',
  'notification_all.all_filtered_selected':
    'All {count} filtered users are selected. Notifications will be sent in batches.',
  'notification_all.filtered_preview_hint':
    'Showing {shown} of {total} matching users in the dropdown. Use Select All to target the full list.',
  'notification_all.batch_size': 'Batch Size',
  'notification_all.batch_size_tooltip':
    'Number of users per send batch (10–20 recommended to avoid overload)',
  'notification_all.last_login_range_required':
    'Please select a last login date range to send to all filtered users',
  'notification_all.send_notification_button': 'Send Notification',
  'notification_all.reset_button': 'Reset',
  'notification_all.fetch_notification_error':
    'Failed to fetch notification details',
  'notification_all.fetch_users_error': 'Failed to load users',
  'notification_all.variables_invalid': 'Variables must be valid JSON format',
  'notification_all.send_success':
    'Notification sent successfully to {count} users!',
  'notification_all.send_success_batched':
    'Notification queued for {count} users in {batches} batches (up to {batchSize} per batch).',
  'notification_all.sending_in_progress':
    'Sending notification to {count} users in the background...',
  'notification_all.send_error': 'Failed to send notification',
  'notification_all.no_users_found': 'No users found',
  'notification_all.title_required': 'Please enter notification title',
  'notification_all.message_required': 'Please enter notification message',
  'notification_all.all_users': 'All Users',
  'notification_all.active_only': 'Active Only',

  // Dashboard
  'dashboard.admin_dashboard': 'Admin Dashboard',
  'dashboard.users': 'Users',
  'dashboard.new_sellers': 'New Sellers',
  'dashboard.sellers': 'Sellers',
  'dashboard.drop_off_rate_seller': 'Drop-off Rate (Seller)',
  'dashboard.user': 'user',
  'dashboard.dropped': 'dropped',
  'dashboard.active_admins': 'Active Admins',
  'dashboard.online': 'online',
  'dashboard.failed_to_load_dashboard_data': 'Failed to load dashboard data',
  'dashboard.date_range_selected': 'Date range selected: {from} to {to}',
  'dashboard.finance_overview': 'Finance Overview',
  'dashboard.total_in_wallet': 'Total in Wallet',
  'dashboard.pending_disbursement': 'Pending Disbursement',
  'dashboard.efficiency': 'Efficiency',
  'dashboard.click': 'click',
  'dashboard.new_user': 'new user',
  'dashboard.content_activity': 'Content & Activity',
  'dashboard.blogs': 'Blogs',
  'dashboard.services': 'Services',
  'dashboard.products': 'Products',
  'dashboard.care_team_ratio': 'Users with care team / total users',
  'dashboard.care_team_ratio_hint':
    'Shows how many users have an assigned care team.',
  'dashboard.buyers_care_team': 'Buyers with care team / Total users',
  'dashboard.buyers_care_team_hint':
    'Shows how many buyers have selected interests.',
  'dashboard.buyers_care_team_percent':
    'Share of buyers with care team: {percent}%',
  'dashboard.new': 'New',

  // Date Range Selector
  'date_range.select_date_range': 'Select date range',
  'date_range.date_range': 'DATE RANGE',
  'date_range.last_7_days': 'Last 7 days',
  'date_range.this_week': 'This week',
  'date_range.this_month': 'This month',
  'date_range.this_quarter': 'This quarter',
  'date_range.this_year': 'This year',
  'date_range.last_week': 'Last week',
  'date_range.last_month': 'Last month',
  'date_range.last_quarter': 'Last quarter',
  'date_range.last_year': 'Last year',
  'date_range.last_30_days': 'Last 30 days',
  'date_range.last_90_days': 'Last 90 days',
  'date_range.last_365_days': 'Last 365 days',
  'date_range.all_time': 'All time',
  'date_range.today': 'Today',
  'date_range.select': 'Select',
  'date_range.january': 'JANUARY',
  'date_range.february': 'FEBRUARY',
  'date_range.march': 'MARCH',
  'date_range.april': 'APRIL',
  'date_range.may': 'MAY',
  'date_range.june': 'JUNE',
  'date_range.july': 'JULY',
  'date_range.august': 'AUGUST',
  'date_range.september': 'SEPTEMBER',
  'date_range.october': 'OCTOBER',
  'date_range.november': 'NOVEMBER',
  'date_range.december': 'DECEMBER',
  'global.professions': 'Professions',
  'global.search_by_name_or_description': 'Search by name or description...',
  'global.confirm_delete': 'Confirm delete',
  'global.are_you_sure_delete': 'Are you sure to delete',
  'global.interests': 'Interests',
  'global.programs': 'Programs',
  'global.term': 'Term',
  'global.suitable_participants': 'Suitable Participants',
  'global.view_tree': 'View tree',
  'global.no_data': 'No data',
  'interest.tree_view': 'Interest Tree',
  'profession.tree_view': 'Profession Tree',
  'dashboard.publishers': 'Publishers',
  'global.point': 'Lion Point',
  'global.programs': 'Programs',
  'global.term': 'Term',
  'global.suitable_participants': 'Suitable Participants',
  'global.edit_program': 'Edit Program',
  'global.add_program': 'Add Program',
  'global.create_success': 'Create successful!',
  'global.update_success': 'Update successful!',
  'global.create_failed': 'Create failed',
  'global.update_failed': 'Update failed',
  'global.error_fetch_data': 'Failed to fetch data',
  'global.delete_failed': 'Delete failed',
  'global.campaign_policy': 'Campaign Policy',
  'global.campaign_roles': 'Campaign roles',
  'global.commmission_policy': 'Commission Policy',
  'global.search_by_name': 'Search by name...',
  'global.expiration_days': 'Expiration Days',
  'global.enable_tiering': 'Enable Tiering',
  'global.allow_negative_balance': 'Allow Negative Balance',
  'global.valid_from': 'Valid From',
  'global.valid_to': 'Valid To',
  'global.days': 'days',
  'global.true': 'True',
  'global.false': 'False',
  'global.enter_expiration_days': 'Enter expiration days',
  'global.wallets': 'Wallets',
  'interest.fetch_error': 'Failed to fetch interests.',
  'interest.children_button': 'Children',
  'interest.professions_button': 'Professions',
  'interest.children_load_failed': 'Failed to load children.',
  'interest.children_remove_select_warning':
    'Please select children to remove.',
  'interest.children_remove_success': 'Children removed successfully.',
  'interest.children_remove_failed': 'Failed to remove children.',
  'interest.children_add_select_warning': 'Please select children to add.',
  'interest.children_add_success': 'Children added successfully.',
  'interest.children_add_failed': 'Failed to add children.',
  'interest.add_children_label': 'Add Children:',
  'interest.select_children_placeholder': 'Select children to add',
  'interest.current_children_label': 'Current Children:',
  'interest.manage_children_title': 'Manage Children for: {name}',
  'interest.professions_load_failed': 'Failed to load professions.',
  'interest.professions_available_load_failed':
    'Failed to load available professions.',
  'interest.professions_child_only_warning':
    'Professions can only be managed for child interests, not parent interests.',
  'interest.professions_parent_hint':
    'This interest is a parent interest and cannot have professions assigned to it.',
  'interest.professions_remove_select_warning':
    'Please select professions to remove.',
  'interest.professions_remove_success': 'Professions removed successfully.',
  'interest.professions_remove_failed': 'Failed to remove professions.',
  'interest.professions_add_select_warning':
    'Please select professions to add.',
  'interest.professions_add_success': 'Professions added successfully.',
  'interest.professions_add_failed': 'Failed to add professions.',
  'interest.add_professions_label': 'Add Professions:',
  'interest.select_professions_placeholder': 'Select professions to add',
  'interest.current_professions_label': 'Current Professions:',
  'interest.manage_professions_title': 'Manage Professions for: {name}',
  'interest.tree_load_failed': 'Failed to load interest tree data.',
  'interest.load_failed': 'Failed to load interest data.',
  'profession.fetch_error': 'Failed to fetch professions.',
  'profession.children_load_failed': 'Failed to load children.',
  'profession.children_remove_select_warning':
    'Please select children to remove.',
  'profession.children_remove_success': 'Children removed successfully.',
  'profession.children_remove_failed': 'Failed to remove children.',
  'profession.children_add_select_warning': 'Please select children to add.',
  'profession.children_add_success': 'Children added successfully.',
  'profession.children_add_failed': 'Failed to add children.',
  'profession.add_children_label': 'Add Children:',
  'profession.select_children_placeholder': 'Select children to add',
  'profession.current_children_label': 'Current Children:',
  'profession.manage_children_title': 'Manage Children for: {name}',
  'profession.tree_load_failed': 'Failed to load profession tree data.',
  'profession.services_column': 'Services',
  'profession.services_button': 'Services',
  'profession.services_load_failed': 'Failed to load services.',
  'profession.services_available_load_failed':
    'Failed to load available services.',
  'profession.services_remove_select_warning':
    'Please select services to remove.',
  'profession.services_remove_success': 'Services removed successfully.',
  'profession.services_remove_failed': 'Failed to remove services.',
  'profession.services_add_select_warning': 'Please select services to add.',
  'profession.services_add_success': 'Services added successfully.',
  'profession.services_add_failed': 'Failed to add services.',
  'profession.add_services_label': 'Add Services:',
  'profession.select_services_placeholder': 'Select services to add',
  'profession.current_services_label': 'Current Services:',
  'profession.manage_services_title': 'Manage Services for: {name}',
  'serviceSample.menu_title': 'Service Sample',
  'serviceSample.manager_title': 'Service Sample',
  'serviceSample.title': 'Title',
  'serviceSample.description': 'Description',
  'serviceSample.search_placeholder': 'Search by title or description...',
  'serviceSample.fetch_error': 'Failed to fetch service samples.',
  'serviceSample.fetch_detail_failed': 'Failed to fetch service sample detail.',
  'serviceSample.update_success': 'Update successful!',
  'serviceSample.create_success': 'Create successful!',
  'serviceSample.save_failed': 'Failed to save service sample.',
  'serviceSample.title_required': 'Please input title',
  'serviceSample.add_title': 'Add Service Sample',
  'serviceSample.edit_title': 'Edit Service Sample',
  'healthSolution.menu_title': 'Health Solution Library',
  'libraryCategory.menu_title': 'Library Categories',
  'healthSolution.filter_library_category': 'Filter by category',
  'healthSolution.library_categories': 'Categories',
  'libraryCategory.manager_title': 'Library Categories',
  'healthSolution.manager_title': 'Health Solution Library',
  'healthSolution.title': 'Title',
  'healthSolution.method': 'Method & Technology',
  'healthSolution.applicable_when': 'Applicable When',
  'healthSolution.expected_result': 'Expected Result',
  'healthSolution.notes': 'Notes',
  'healthSolution.hashtags': 'Hashtags',
  'healthSolution.hashtags_placeholder': 'Type a tag and press Enter',
  'healthSolution.categories': 'Categories',
  'healthSolution.categories_placeholder': 'Select categories',
  'healthSolution.request_template': 'Request Template',
  'healthSolution.offer_template': 'Offer Template',
  'healthSolution.ordering': 'Ordering',
  'healthSolution.is_active': 'Active',
  'libraryCategory.is_active': 'Visible',
  'libraryCategory.is_active_hint': 'Hidden categories disappear from the public Health Library (filters and labels). Solutions stay visible.',
  'libraryCategory.filter_status': 'All statuses',
  'libraryCategory.status_visible': 'Visible',
  'libraryCategory.status_hidden': 'Hidden',
  'libraryCategory.status_updated': 'Status updated',
  'libraryCategory.status_failed': 'Failed to update status',
  'healthSolution.filter_status': 'All statuses',
  'healthSolution.status_active': 'Active',
  'healthSolution.status_hidden': 'Hidden',
  'healthSolution.search_placeholder': 'Search by title/method/notes...',
  'healthSolution.filter_category': 'Filter by category',
  'healthSolution.import_csv': 'Import CSV',
  'healthSolution.download_template': 'CSV Template',
  'healthSolution.import_result': 'Import result',
  'healthSolution.import_created': 'Created',
  'healthSolution.import_failed': 'Failed',
  'healthSolution.import_failed_msg': 'Failed to import CSV.',
  'healthSolution.status_failed': 'Failed to update status.',
  'healthSolution.fetch_error': 'Failed to fetch health solutions.',
  'healthSolution.fetch_detail_failed': 'Failed to fetch health solution detail.',
  'healthSolution.update_success': 'Update successful!',
  'healthSolution.create_success': 'Create successful!',
  'healthSolution.save_failed': 'Failed to save health solution.',
  'healthSolution.title_required': 'Please input title',
  'healthSolution.add_title': 'Add Health Solution',
  'healthSolution.edit_title': 'Edit Health Solution',
  'global.saved_success': 'Saved successfully!',
  'global.saved_failed': 'Saved failed!',
  'global.sent_to_seller': 'Sent to seller',
  'global.sent_to_buyer': 'Sent to buyer',
  'global.reporter': 'Reporter',
  'global.reporter_id': 'Reporter ID',
  'global.post_id': 'Post ID',
  'global.post': 'Post',
  'global.resolved': 'Resolved',
  'global.copy_success': 'Copy successfully',
  'global.copy_failed': 'Cannot copy',
  'global.load_data_failed': 'Failed to load data',
  'global.select_reporter': 'Select reporter',
  'global.select_post': 'Select post',
  'global.enter_report_type': 'Enter report type',
  'global.enter_report_content': 'Enter report content',
  'global.enter_image_urls': 'Enter image URLs separated by comma',
  'global.enter_image_urls_example':
    'Enter image URLs separated by comma (e.g., https://example.com/image1.jpg, https://example.com/image2.jpg)',
  'global.report_not_found': 'Report not found',
  'global.voice': 'Voice',
  'global.voices': 'Voices',
  'global.audio_assets': 'Audio Assets',
  'global.audio_preview': 'Audio Preview',
  'global.audio_not_supported':
    'Your browser does not support the audio element.',
  'global.play': 'Play',
  'global.storage_url': 'Storage URL',
  'global.mime_type': 'MIME Type',
  'global.codec': 'Codec',
  'global.container': 'Container',
  'global.sample_rate': 'Sample Rate (Hz)',
  'global.duration': 'Duration',
  'global.size': 'Size',
  'global.fraud': 'Fraud',
  'global.ip_infringement': 'IP Infringement',
  'global.under_18': 'Under 18',
  'global.violence': 'Violence',
  'global.released': 'Released',
  'global.withdrawaled': 'Withdrawaled',
  'global.failed_to_fetch_user_revenue_list':
    'Failed to fetch user revenue list!',
  'global.delete_user_revenue_failed': 'Delete user revenue failed!',
  'global.status_pending': 'Pending',
  'global.status_released': 'Released',
  'global.status_withdrawaled': 'Withdrawaled',
  'global.countered': 'Countered',
  'global.expert_management': 'User Selections Management',
  'global.expert': 'Expert',
  'global.user_picker': 'User Picker',
  'global.professionals_report': 'Professionals report',
  'global.unknown': 'Unknown',
  'chat.messages_of_channel': 'Messages of channel',
  'chat.delete_all_messages': 'Delete all messages',
  'chat.no_messages': 'No messages',
  'chat.text': 'text',
  'chat.voice_message': 'Voice message',
  'chat.image_message': 'Image message',
  'chat.message_copied_to_clipboard': 'Message copied to clipboard',
  'chat.failed_to_copy_message': 'Failed to copy message',
  'chat.load_more_older_messages': 'Load more (older messages)',
  'chat.cannot_load_more_messages': 'Cannot load more messages',
  'chat.please_enter_delete_reason': 'Please enter delete reason',
  'chat.all_messages_deleted_successfully': 'All messages deleted successfully',
  'chat.delete_messages_failed': 'Delete messages failed, please try again',
  'chat.delete_all_channel_messages': 'Delete all channel messages',
  'chat.delete': 'Delete',
  'chat.confirm_delete_all_messages': 'Are you sure you want to delete',
  'chat.all': 'all',
  'chat.delete_action_irreversible':
    'This action cannot be undone. Backend will log audit.',
  'chat.delete_reason_required': 'Delete reason (required)',
  'chat.enter_delete_reason_placeholder': 'Enter delete reason (required)',
  'chat.sticker': 'Sticker',
  'chat.offer': 'Offer',
  'chat.files': 'Files',
  'chat.order_no': 'Order No',
  'chat.file_viewer': 'File Viewer',
  'chat.download': 'Download',
  'chat.file_preview_not_available': 'Preview not available for this file type',
  'chat.download_to_view': 'Download to view',
  'chat.delete_single_message': 'Delete single message',
  'chat.confirm_delete_this_message': 'Confirm delete this message',
  'chat.chat_information': 'Chat Information',
  'chat.members': 'members',
  'chat.failed_to_load_messages': 'Failed to load messages',
  'chat.message_deleted_successfully': 'Message deleted successfully',
  'chat.delete_message_failed': 'Delete message failed',
  'global.audit-logs-chat': 'Audit logs chat',
  'global.unknown': 'Unknown',
  'global.add_voucher': 'Add voucher',
  'global.fixed_amount': 'Fixed amount',
  'global.percentage': 'Percentage',
  'global.caption': 'Caption',
  'global.author': 'Author',
  'global.audio': 'Audio',
  'global.visibility': 'Visibility',
  'global.replies_count': 'Replies Count',
  'global.play_count': 'Play Count',
  'global.voice_posts': 'Voice Posts',
  'global.search_firstname_lastname_email':
    'Search first name, last name, email',
  'global.filter_by_role': 'Filter by Role',
  'global.total_users': 'Total users',
  'global.user_today': 'User today',
  'global.user_this_week': 'User this week',
  'global.user_this_month': 'User this month',
  'global.seller_today': 'Seller today',
  'global.seller_this_week': 'Seller this week',
  'global.seller_this_month': 'Seller this month',
  'global.replies': 'Replies',
  'global.plays': 'Plays',
  'global.likes': 'Likes',
  'global.shares': 'Shares',
  'global.hashtag': 'Hashtag',
  'global.user_follows': 'User Follows',
  'global.follower_count': 'Followers',
  'global.following_count': 'Following',
  'global.direct_message': 'DM',
  'global.email_copied_to_clipboard': 'Email copied to clipboard',
  'voice_posts.search_author_placeholder':
    'Search by applies to caption, title, author',
  'voice_posts.post_source_user': 'User posts',
  'voice_posts.post_source_system': 'System posts',
  'voice_posts.fake_comment_templates': 'Seeding Comment Template',
  'voice_posts.add_fake_comment_template': 'Add Template',
  'voice_posts.edit_fake_comment_template': 'Edit Template',
  'voice_posts.fake_comment_template_create_success': 'Template created successfully',
  'voice_posts.fake_comment_template_update_success': 'Template updated successfully',
  'voice_posts.delete_fake_comment_template_confirm': 'Delete fake comment template #{id}?',
  'voice_posts.run_fake_comments': 'Run Seeding Comments',
  'voice_posts.fake_comment_random_author_hint': 'When running seeding, the system randomly selects sample % from posts without comments (posts that already have replies are skipped). Comment authors are assigned randomly from activated users. Templates only store content (text, voice, icon).',
  'voice_posts.fake_comment_hashtags_hint': 'Optional. This template prefers posts with any of these hashtags (OR). If no matching posts in the run, it falls back to general seeding.',
  'voice_posts.select_hashtags': 'Select hashtags (optional)',
  'voice_posts.fake_comments_success': 'Seeding comments generated successfully',
  'voice_posts.fake_comments_failed': 'Failed to generate seeding comments',
  'voice_posts.min_comments': 'Min comments per post',
  'voice_posts.max_comments': 'Max comments per post',
  'voice_posts.sample_percent': 'Sample percent of posts (%)',
  'voice_posts.random_lang_percent': 'Random template percent (%)',
  'voice_posts.matching_lang_percent_hint': 'Remaining {percent}% will use matching template language',
  'voice_posts.random_lang_percent_rule': 'Must not exceed total sample percent',
  'voice_posts.estimated_matching_lang_selected': 'Est. matching lang posts',
  'voice_posts.estimated_random_lang_selected': 'Est. random lang posts',
  'voice_posts.post_ids_optional': 'Post IDs (optional, comma-separated)',
  'voice_posts.seeding_time_range': 'Voice post time range',
  'voice_posts.seeding_time_range_required': 'Please select a time range',
  'voice_posts.author_id_optional': 'Author ID (optional)',
  'voice_posts.preview_seeding_posts': 'Preview eligible posts',
  'voice_posts.preview_seeding_failed': 'Failed to load preview',
  'voice_posts.total_posts_in_range': 'Total posts in range',
  'voice_posts.posts_already_commented': 'Already commented',
  'voice_posts.posts_available': 'Available for seeding',
  'voice_posts.posts_matching_lang': 'Matching template language',
  'voice_posts.posts_fallback_random': 'Using random template pool',
  'voice_posts.estimated_selected': 'Estimated selected posts',
  'voice_posts.estimated_matching_lang': 'Est. matching lang / random',
  'voice_posts.estimated_lang_breakdown_hint': 'matching lang / random among estimated selected',
  'voice_posts.template_lang_matched': 'Template language',
  'voice_posts.template_lang_matched_yes': 'Lang matched',
  'voice_posts.template_lang_fallback': 'Random pool',
  'voice_posts.seeding_run_summary': 'Seeding run summary',
  'voice_posts.posts_selected': 'Posts selected',
  'voice_posts.comments_created': 'Comments created',
  'voice_posts.emoji_or_text': 'Emoji or text',
  'voice_posts.audio_id_required': 'Audio ID is required for voice type',
  'voice_posts.image_urls_required': 'At least one image URL is required',
  'voice_posts.one_url_per_line': 'One URL per line',
  'voice_posts.author_id_required': 'Author ID is required to upload audio',
  'voice_posts.author_id_upload_hint': 'Required when uploading new audio',
  'voice_posts.audio_upload_failed': 'Upload audio failed',
  'voice_posts.image_upload_failed': 'Upload image failed',
  'voice_posts.emoji_or_image_required': 'Emoji/text or image is required for icon type',
  'voice_posts.analytics_title': 'Voice Analytics',
  'voice_posts.analytics_back_to_posts': 'Back to Voice Posts',
  'voice_home_widgets.title': 'Voice Home Widgets',
  'voice_home_widgets.back_to_posts': 'Back to Voice Posts',
  'voice_home_widgets.seed': 'Seed defaults',
  'voice_home_widgets.hint':
    'Widgets are inserted into the Voice Home feed after the N-th voice_post. Flutter only renders the order returned by the API.',
  'voice_home_widgets.preview': 'Preview order:',
  'voice_home_widgets.widget_type': 'Widget',
  'voice_home_widgets.enabled': 'Enabled',
  'voice_home_widgets.position': 'After post #',
  'voice_home_widgets.position_hint':
    'Insert widget after this many voice posts in the feed session',
  'voice_home_widgets.priority': 'Priority',
  'voice_home_widgets.priority_hint':
    'Higher wins when two widgets share a position',
  'voice_home_widgets.repeatable': 'Repeatable',
  'voice_home_widgets.payload_limit': 'Items in widget',
  'voice_home_widgets.extra': 'Extra JSON',
  'voice_home_widgets.extra_hint':
    'For strongbody_discovery: title, subtitle, image_url, cta_url, cta_label',
  'voice_home_widgets.edit': 'Edit widget',
  'voice_home_widgets.load_failed': 'Failed to load Voice Home widgets',
  'voice_home_widgets.update_success': 'Widget updated',
  'voice_home_widgets.update_failed': 'Update failed',
  'voice_home_widgets.seed_created': 'Default widgets seeded',
  'voice_home_widgets.seed_exists': 'Widgets already exist',
  'voice_home_widgets.seed_failed': 'Seed failed',
  'voice_home_widgets.invalid_extra_json': 'extra must be valid JSON',
  'voice_posts.analytics_load_failed': 'Failed to load voice analytics',
  'voice_posts.analytics_range_hint': 'Statistics by selected date range. Popular voices use all-time qualified plays (>50).',
  'voice_posts.analytics_date': 'Date',
  'voice_posts.analytics_total_replies': 'Replies',
  'voice_posts.analytics_total_plays': 'Plays',
  'voice_posts.analytics_author': 'Author',
  'voice_posts.analytics_topic': 'Topic',
  'voice_posts.analytics_play_count': 'Plays',
  'voice_posts.analytics_post_count': 'Posts',
  'voice_posts.analytics_avg_duration': 'Avg duration',
  'voice_posts.analytics_note': 'Note',
  'voice_posts.analytics_admin_posted': 'Admin posted',
  'voice_posts.analytics_uncategorized': 'Uncategorized',
  'voice_posts.analytics_retention_ratio': 'Retention ratio',
  'voice_posts.analytics_avg_post_duration': 'Avg post duration',
  'voice_posts.analytics_popular_count': 'Popular voices (>50 plays)',
  'voice_posts.analytics_daily_activity': 'Daily replies & plays',
  'voice_posts.analytics_popular_voices': 'Popular voices',
  'voice_posts.analytics_popular_voices_hint': 'All-time, >50 qualified plays',
  'voice_posts.analytics_listens_by_country': 'Listens by country',
  'voice_posts.analytics_listens_by_topic': 'Listens by topic',
  'voice_posts.analytics_frequent_posters': 'Frequent posters (>2 posts)',
  'voice_posts.no_speech_title': 'No-speech posts',
  'voice_posts.no_speech_hint_title': 'Posts with little or no speech text',
  'voice_posts.no_speech_hint':'STT text',
  'voice_posts.no_speech_scan': 'Scan old posts',
  'voice_posts.no_speech_scan_confirm_title': 'Scan posts for speech?',
  'voice_posts.no_speech_scan_confirm_content':
    'Run STT on pending posts in the selected range (default last 15 days). Posts already checked are skipped unless you rescan.',
  'voice_posts.no_speech_scan_success': 'Scan completed',
  'voice_posts.no_speech_scan_failed': 'Scan failed',
  'voice_posts.no_speech_scan_result': 'Scan result',
  'voice_posts.no_speech_scanned': 'Scanned',
  'voice_posts.no_speech_remaining': 'Remaining',
  'voice_posts.no_speech_min_chars': 'Min speech chars',
  'voice_posts.no_speech_confirm_hide': 'Confirm → Draft',
  'voice_posts.no_speech_hide_confirm_title': 'Hide selected posts as draft?',
  'voice_posts.no_speech_hide_confirm_content':
    'Confirm {count} no-speech post(s). They will be set to draft and hidden from the public feed.',
  'voice_posts.no_speech_hide_success': 'Hid {count} post(s) as draft',
  'voice_posts.no_speech_hide_failed': 'Failed to hide posts as draft',
  'voice_posts.no_speech_load_failed': 'Failed to load no-speech posts',
  'voice_posts.no_speech_empty': 'No flagged posts in this range',
  'voice_posts.no_speech_by_day': 'By day',
  'voice_posts.no_speech_all_days': 'All days',
  'voice_posts.no_speech_filter_by_day': 'Filter by day',
  'voice_posts.no_speech_stt_text': 'STT text',
  'voice_posts.no_speech_empty_text': 'Empty',
  'voice_posts.no_speech_status': 'Speech check',
  'voice_posts.no_speech_note': 'Note',
  'voice_posts.no_speech_status_no_speech': 'No speech',
  'voice_posts.no_speech_status_pending': 'Pending',
  'voice_posts.no_speech_status_has_speech': 'Has speech',
  'voice_posts.no_speech_status_failed': 'Failed',
  'voice_posts.no_speech_status_all': 'All statuses',
  'voice_posts.no_speech_status_unknown': 'Unknown',
  'global.actions': 'Actions',
  'global.language_required': 'Language is required',
  'global.filter_by_language': 'Filter by language',
  'global.filter_by_country': 'Filter by author country',
  'global.filter_by_post_source': 'Filter by post source',
  'global.run': 'Run',
  'global.optional': 'Optional',
  'global.edit_profession': 'Edit Profession',
  'global.add_profession': 'Add Profession',
  'global.basic_info': 'Basic Info',
  'global.profession_manager': 'Profession Manager',
  'global.please_input_profession_name': 'Please input profession name',
  'profession.add_children_hint':
    'Select professions to add as children. Only professions without children can be added.',
  'profession.save_first_children':
    'Select children and click Save to create profession with children',
  'profession.children_save_hint':
    'Select children above and click Save to apply changes',
  'profession.no_children': 'No children added yet',
  'profession.add_services_hint':
    'Select service samples to associate with this profession.',
  'profession.save_first_services':
    'Select services and click Save to create profession with services',
  'profession.services_save_hint':
    'Select services above and click Save to apply changes',
  'profession.no_services': 'No services added yet',
  'profession.children_count':
    '{count, plural, =0 {No children} =1 {1 child} other {# children}}',
  'profession.services_count':
    '{count, plural, =0 {No services} =1 {1 service} other {# services}}',
  'global.edit_interest': 'Edit Interest',
  'global.add_interest': 'Add Interest',
  'global.interest_manager': 'Interest Manager',
  'global.interest_saved': 'Interest saved successfully',
  'global.failed_to_save_interest': 'Failed to save interest',
  'global.please_input_interest_name': 'Please input interest name',
  'interest.add_children_hint':
    'Select interests to add as children. Only leaf interests can be added.',
  'interest.save_first_children': 'Save interest first to add children',
  'interest.children_save_hint':
    'Select children above and click Save to apply changes',
  'interest.no_children': 'No children added yet',
  'interest.professions_tab': 'Professions',
  'interest.add_professions_hint':
    'Select professions to associate with this interest.',
  'interest.save_first_professions': 'Save interest first to add professions',
  'interest.professions_save_hint':
    'Select professions above and click Save to apply changes',
  'interest.no_professions': 'No professions added yet',
  'interest.children_count':
    '{count, plural, =0 {No children} =1 {1 child} other {# children}}',
  'interest.professions_count':
    '{count, plural, =0 {No professions} =1 {1 profession} other {# professions}}',
  'dashboard.daily_overview': 'Daily Overview',
  'daily_report.total_seller_hr': 'Total HR Freelance',
  'daily_report.total_seller_sale_voice': 'Total Sale Voice',
  'daily_report.total_seller_sale_shop_active': 'Total Sale Product',
  'daily_report.total_seller_sale_buy_website': 'Total Sale Buy Website',
  'daily_report.total_seller_sale_profile': 'Total Sale Profile',
  'daily_report.total_seller_edu': 'Total Edu',
  'daily_report.total_seller_other': 'Total Partner',
  'daily_report.new_seller_hr_daily': 'New HR Freelance',
  'daily_report.new_seller_sale_voice_daily': 'New Sale Voice',
  'daily_report.new_seller_sale_shop_active_daily': 'New Sale Product',
  'daily_report.new_seller_sale_buy_website_daily': 'New Sale Buy Website',
  'daily_report.new_seller_sale_profile_daily': 'New Sale Profile',
  'daily_report.new_seller_edu_daily': 'New Edu',
  'daily_report.new_seller_other_daily': 'New Partner',
  'daily_report.title': 'Daily Report',
  'daily_report.load_failed': 'Failed to load daily report',
  'daily_report.user_statistics': 'User Statistics',
  'daily_report.section_seller': 'Seller',
  'daily_report.section_seller_desc':
    'Seller accounts on the platform, split by Sale (commerce) and HR (recruitment) channels',
  'daily_report.section_user': 'User',
  'daily_report.section_user_desc':
    'New users split by sign-up channel: Web and Mobile (Android + iOS)',
  'daily_report.all_time_badge': 'All Time',
  'daily_report.section_content_activity': 'Content & Activity',
  'daily_report.section_content_activity_desc':
    'Services, products, voice and requests in the selected date range',
  'daily_report.new_users_formula':
    'New users = Web + Mobile (Android + iOS)',
  'daily_report.total_sellers_formula': 'Total sellers = Sale + HR',
  'daily_report.new_sellers_formula': 'New sellers = Sale + HR',
  'daily_report.section_campaign': 'Affiliate campaigns',
  'daily_report.section_campaign_desc':
    'Users, sign-ups and clicks per campaign in the selected period',
  'daily_report.campaign_filter_range': 'Filter period',
  'daily_report.campaign_col_name': 'Campaign',
  'daily_report.campaign_col_users': 'Users',
  'daily_report.campaign_col_signups': 'Sign-ups',
  'daily_report.campaign_col_clicks': 'Clicks',
  'daily_report.campaign_summary_users': 'Campaign users',
  'daily_report.campaign_summary_signups': 'Campaign sign-ups',
  'daily_report.campaign_summary_clicks': 'Campaign clicks',
  'daily_report.google_ads_title': 'Google Ads — Daily Report',
  'google_ads.campaigns': 'Campaigns',
  'google_ads.cost_report': 'Cost Report',
  'google_ads.daily_report': 'Daily Report',
  'google_ads.install_report': 'Install Report',
  'google_ads.notes_title': 'Metrics Explanation',
  'google_ads.cost': 'Cost',
  'google_ads.clicks': 'Clicks',
  'google_ads.impressions': 'Impressions',
  'google_ads.conversions': 'Conversions',
  'google_ads.ctr': 'Click Through Rate',
  'google_ads.avg_cpc': 'Average Cost Per Click',
  'google_ads.all_conversions': 'Total Conversions',
  'google_ads.install': 'App Installs',
  'google_ads.first_open': 'First Opens',
  'google_ads.cost_per_conversion': 'Cost Per Conversion',
  'google_ads.conversion_rate': 'Conversion Rate',
  'google_ads.status': 'Status',
  'google_ads.no_data': 'No data available for the selected period.',
  'google_ads.campaign': 'Campaign',
  'google_ads.account_id': 'Account ID',
  'google_ads.campaign_id': 'Campaign ID',
  'appsflyer.organic_app_button': 'Organic app installs',
  'appsflyer.organic_app_title': 'AppsFlyer app install report',
  'appsflyer.media_source_button': 'Media source performance',
  'appsflyer.media_source_title': 'AppsFlyer media source performance',
  'appsflyer.report_button': 'Combined install report',
  'appsflyer.report_title': 'AppsFlyer combined install report',
  'appsflyer.load_failed': 'Failed to load AppsFlyer report',
  'appsflyer.notes_title': 'AppsFlyer endpoints',
  'appsflyer.organic_installs_desc': 'Uses /v1/appsflyer/report. Shows organic installs, total installs, clicks and media sources. AppsFlyer response does not include impressions.',
  'appsflyer.media_source_desc': 'Clicks and installs grouped by media_source/campaign from AppsFlyer.',
  'appsflyer.report_desc': 'Combined API: organic_installs plus campaign_performance from AppsFlyer.',
  'appsflyer.organic_installs': 'Organic installs',
  'appsflyer.total_installs': 'Total installs',
  'appsflyer.organic_installs_array': 'Organic installs by platform/app/date',
  'appsflyer.campaign_performance': 'Campaign performance rows',
  'appsflyer.clicks': 'Clicks',
  'appsflyer.media_sources': 'Media sources',
  'appsflyer.media_source': 'Media source',
  'appsflyer.campaign': 'Campaign',
  'appsflyer.platform': 'Platform',
  'appsflyer.app_id': 'App ID',
  'appsflyer.installs': 'Installs',
  'appsflyer.date': 'Date',
  'appsflyer.no_data': 'No Appsflyer data',
  'appsflyer.no_data_desc': 'Try another date range or check whether Appsflyer sync has run.',
  'daily_report.section_downloads': 'App downloads & sign-ups',
  'daily_report.section_downloads_desc':
    'Sign-up counts by platform in the selected date range',
  'daily_report.section_mobile': 'Mobile',
  'daily_report.section_mobile_desc':
    'Mobile total = Android + iOS (within selected date range)',
  'daily_report.section_web_signups': 'Sign-up via Web',
  'daily_report.section_web_signups_desc':
    'Web sign-ups, affiliate conversions and invite links in the selected date range',
  'daily_report.section_service': 'Service',
  'daily_report.section_product': 'Product',
  'daily_report.section_voice': 'Voice',
  'daily_report.section_voice_desc': 'Voice posts — short updates on the app',
  'daily_report.section_request': 'Request',
  'daily_report.section_request_desc':
    'Buyer requests to find sellers, created by users or staff',
  'daily_report.context_range': 'Viewing: {from} → {to}',
  'daily_report.context_no_range':
    'No date range selected — pick dates (top right) to filter metrics',
  'daily_report.reading_guide':
    '"Historical totals" ignore the date filter. New users = Web + Mobile; Mobile = Android + iOS.',
  'daily_report.row_all_time': 'Historical totals — not affected by date filter',
  'daily_report.row_in_period': 'Within selected date range',
  'daily_report.row_mobile_breakdown': 'Breakdown by platform',
  'daily_report.row_web_signups': 'Web sign-ups',
  'daily_report.row_affiliate_signups': 'Affiliate & invite link',
  'daily_report.hint_all_time': 'Total since launch',
  'daily_report.hint_in_period': 'Based on selected dates above',
  'daily_report.data_calculation_note':
    '* Data is calculated from 6 AM of the previous day to 6 AM of the next day (Vietnam time)',
  'daily_report.total_users': 'Total Users',
  'daily_report.all_time': 'Cumulative',
  'daily_report.new_users_daily': 'New users',
  'daily_report.signup_android': 'Android sign-ups',
  'daily_report.signup_ios': 'iOS sign-ups',
  'daily_report.in_selected_period': 'Filtered',
  'daily_report.total_sellers': 'Total Sellers',
  'daily_report.new_sellers_daily': 'New sellers',
  'daily_report.service_product_statistics': 'Services & Products',
  'daily_report.service_product_statistics_desc':
    'Services and products listed by sellers on the app',
  'daily_report.total_services': 'Total active services',
  'daily_report.new_services_daily': 'New services listed',
  'daily_report.total_products': 'Total active products',
  'daily_report.new_products_daily': 'New products listed',
  'daily_report.voice_statistics': 'Voice Statistics',
  'daily_report.total_voice_posts': 'Total Voice Posts',
  'daily_report.new_voice_posts_daily': 'New Voice Posts',
  'daily_report.new_voice_posts_by_user_daily': 'Voice by Users',
  'daily_report.new_voice_posts_by_owner_daily': 'Voice by Staff (on behalf)',
  'daily_report.total_voice_comments': 'Total Comments',
  'daily_report.new_voice_comments_daily': 'New Comments',
  'daily_report.total_voice_likes': 'Total Likes',
  'daily_report.new_voice_likes_daily': 'New Likes',
  'daily_report.total_voice_shares': 'Total Shares',
  'daily_report.total_voice_listens': 'Total Listens',
  'daily_report.new_voice_listens_daily': 'New Listens',
  'daily_report.request_statistics': 'Request Statistics',
  'daily_report.total_requests': 'Total Requests',
  'daily_report.new_requests': 'New Requests',
  'daily_report.requests_by_user': 'Requests by User',
  'daily_report.requests_by_staff': 'Requests by Staff',
  'daily_report.aff_conversion_statistics': 'Affiliate Conversion Statistics',
  'daily_report.aff_total_signup_conversions': 'Sign-ups via web invite',
  'daily_report.app_signups_via_invitation': 'Sign-ups via app invite',
  'daily_report.payment_statistics': 'Payment Statistics',
  'daily_report.payment_type_total': 'Total',
  'daily_report.payment_type_user_subscription': 'User subscription payments',
  'daily_report.payment_type_user_subscription_desc':
    'Payment transactions for user subscription plans',
  'daily_report.payment_type_offer': 'Offer payments',
  'daily_report.payment_type_offer_desc':
    'Payment transactions from offers / quotes',
  'daily_report.total_payments': 'Total transactions',
  'daily_report.successful_count': 'Successful transactions',
  'daily_report.failed_count': 'Failed transactions',
  'daily_report.new_payments_daily': 'New payments today',
  'daily_report.total_amount_daily': 'Amount collected today',
  'daily_report.total_amount': 'Total amount (all time)',
  'daily_report.success_rate': 'Success Rate',
  'daily_report.success_failed_count':
    '{successful} successful / {failed} failed',
  'daily_report.new_users_exclude_vn': 'New Users (Exclude Vietnam)',
  'daily_report.new_sellers_exclude_vn': 'New Sellers (Exclude Vietnam)',
  'daily_report.signup_web': 'Sign-ups via Web',
  'daily_report.signup_mobile': 'App downloads (Android + iOS)',
  'global.channel_message_manager': 'Channel Message Manager',
  'global.channel': 'Channel',
  'chat.audit.search_channel': 'Search channel',
  'chat.audit.search_admin': 'Search admin',
  'chat.audit.no_admin_found': 'No admin found',
  'chat.audit.action': 'Action',
  'chat.audit.admin': 'Admin',
  'chat.audit.channel': 'Channel',
  'chat.audit.description': 'Description',
  'chat.audit.created_at': 'Created At',
  'chat.audit.id': 'ID',
  'global.channel_name': 'Channel Name',
  'global.search_create_name': 'Search create name',
  'chat.search_creator_placeholder': 'Search creator email or name',
  'chat.search_creator_hint': 'Matches creator email, first name, or last name (server-side).',
  'global.promotions': 'Promotions',
  'global.vouchers': 'Vouchers',
  'global.sub_description': 'Sub Description',
  'global.idempotencyKey': 'Idempotency Key',
  'global.balance_cents': 'Balance (Cents)',
  'global.expired_cents': 'Expired (Cents)',
  'global.last_transaction_at': 'Last Transaction At',
  'global.pending_cents': 'Pending (Cents)',
  'global.subscription_plan': 'Subscription plan',
  'global.renewal_count': 'Renewal count',
  'global.subscriptions': 'Subscriptions user',
  'global.subscriptions_manager_user': 'Subscriptions user manager',
  'global.chat_bot': 'Chat Bot',
  'global.chat_bot_manager': 'Chat Bot Manager',
  'chat_bot.openai_thread': 'OpenAI Thread',
  'chat_bot.thread_id': 'Thread ID',
  'chat_bot.direction': 'Direction',
  'chat_bot.interaction_type': 'Interaction Type',
  'chat_bot.action_type': 'Action Type',
  'chat_bot.message': 'Message',
  'chat_bot.valid': 'Valid',
  'chat_bot.invalid': 'Invalid',
  'chat_bot.payload': 'Payload',
  'chat_bot.raw_json': 'Raw JSON',
  'chat_bot.parsed_json': 'Parsed JSON',
  'global.interaction_detail': 'Interaction Detail',
  'global.back': 'Back',
  'global.chat-bot': 'Chat Bot',
  'global.total_voice_posts': 'Total Voice Posts',

  // Categories
  'categories.interest': 'Interest',
  'categories.product_count': 'Product Count',
  'categories.service_count': 'Service Count',
  'categories.reorder_categories': 'Reorder Categories',
  'categories.save_order': 'Save Order',
  'categories.loading_categories': 'Loading categories...',
  'categories.order_label': 'Order',
  'categories.failed_to_load_categories_for_ordering':
    'Failed to load categories for ordering',
  'categories.order_updated_successfully': 'Order updated successfully',
  'categories.failed_to_update_order': 'Failed to update order',
  'categories.depth': 'Depth',
  'categories.id_label': 'ID',
  'chat_bot.user_email': 'User Email',

  // LDP Inquiries
  'ldp_inquiries.title': 'LDP Inquiries',
  'ldp_inquiries.get_all': 'Get All',
  'ldp_inquiries.full_name': 'Full Name',
  'ldp_inquiries.area': 'Area',
  'ldp_inquiries.work_preference': 'Work Preference',
  'ldp_inquiries.contact_request': 'Contact Request',
  'ldp_inquiries.phone': 'Phone',
  'ldp_inquiries.scope': 'Scope',
  'ldp_inquiries.scope_admin_dashboard': 'Admin Dashboard',
  'ldp_inquiries.scope_network': 'Network',
  'ldp_inquiries.scope_local': 'Local',
  'ldp_inquiries.no_data_to_export': 'No data to export',
  'ldp_inquiries.exported_successfully':
    'Exported {count} records successfully',
  'ldp_inquiries.api_error': 'API returned an error',
  'ldp_inquiries.fetch_failed': 'Failed to fetch inquiries',
  'ldp_inquiry_send_emails.title': 'LDP Inquiry Send Emails',
  'ldp_inquiry_send_emails.create_title': 'Create inquiry send email',
  'ldp_inquiry_send_emails.view_title': 'Inquiry send email detail',
  'ldp_inquiry_send_emails.full_name': 'Full name',
  'ldp_inquiry_send_emails.full_name_required': 'Full name is required',
  'ldp_inquiry_send_emails.request': 'Request',
  'ldp_inquiry_send_emails.request_required': 'Request is required',
  'ldp_inquiry_send_emails.files': 'Files',
  'ldp_inquiry_send_emails.files_hint': 'Optional. Comma-separated file URLs',
  'ldp_inquiry_send_emails.fetch_failed': 'Failed to fetch inquiry send emails',
  'ldp_inquiry_send_emails.search_placeholder':
    'Search by full name or email...',
  'global.metadata': 'Metadata',
  'global.metadata_label': 'Metadata',
  'global.metadata_value': 'Metadata Value',
  'global.metadata_key': 'Metadata Key',
  'global.metadata_key_value': 'Metadata Key Value',
  'global.metadata_key_value_label': 'Metadata Key Value',
  'global.metadata_key_value_value': 'Metadata Key Value',
  'global.metadata_key_value_label': 'Metadata Key Value',
  'global.general_info': 'General Info',
  'global.general_info_label': 'General Info',
  'global.general_info_value': 'General Info Value',
  'global.general_info_key': 'General Info Key',
  'global.general_info_key_value': 'General Info Key Value',
  'global.affiliate_tier': 'Affiliate Tier',
  'affiliate.tier_management': 'Affiliate Tier Management',
  'affiliate.add_tier': 'Add Affiliate Tier',
  'affiliate.edit_tier': 'Edit Affiliate Tier',
  'affiliate.min_conversions': 'Min Conversions',
  'affiliate.max_conversions': 'Max Conversions',
  'affiliate.commission_rate': 'Commission Rate (%)',
  'affiliate.platform_fee_discount': 'Platform Fee Discount (%)',
  'affiliate.bonus_amount': 'Bonus Amount',
  'affiliate.benefits': 'Benefits',
  'global.add_benefit': 'Add Benefit',
  'affiliate.conversions': 'Conversions Range',
  'affiliate.required_conversions': 'Required Conversions',
  'global.preview': 'Preview',
  'global.text': 'Text',
  'global.number_of_seeds': 'Number of seeds',
  'global.number_of_seeds_required': 'Number of seeds is required',
  'global.contact_info': 'Contact Info',
  'global.members': 'Members',
  'global.updated_by_users': 'Updated By Users',
  'global.no_users_found': 'No users found',
  'global.delete_error': 'Delete error',
  'global.failed_to_load_user_info': 'Failed to load user information',
  'global.click_to_view_updaters_count': 'Click to view all {count} updater(s)',
  'global.click_to_view_updater': 'Click to view updater information',
  'global.owner_email_copied': 'Owner email copied',
  'global.contact_email_copied': 'Contact email copied',
  'global.shop_name_name': 'Shop Name / Name',
  'global.members_of': 'Members of',
  'global.search_by_email_placeholder': 'Search by email...',
  'global.email_copied': 'Email copied',
  'global.add_member': 'Add member',
  'global.seller': 'Seller',
  'global.search_user_placeholder': 'Search by email, name...',
  'global.select_seller': 'Select seller',
  'global.no_sellers_found': 'No sellers found',
  'global.select_categories': 'Select categories',
  'global.enter_description': 'Enter description...',
  'global.require_certificate_image': 'Please upload certificate image',
  'global.certificate_saved': 'Certificate saved successfully',
  'global.form_validation_failed': 'Please fill in all required fields',
  'global.create_success': 'Create succeed!',
  'global.update_success': 'Update succeed!',
  'global.update_error': 'Update error',
  'global.fetch_failed': 'Failed to fetch data',
  'global.add_success': 'Add successfully',
  'global.add_failed': 'Add failed',
  'global.delete_failed': 'Delete failed',

  // Dashboard Stats
  'dashboard.admin_dashboard': 'Admin Dashboard',
  'dashboard.overview': 'Overview',
  'dashboard.voice_engagement': 'Voice & Engagement',
  'dashboard.engagement': 'Engagement',
  'dashboard.daily_report': 'Daily Report',
  'dashboard.days': 'days',
  'dashboard.view_all': 'View all',
  'dashboard.total': 'Total',
  'dashboard.new_users': 'New Users',
  'dashboard.new_blogs': 'New Blogs',
  'dashboard.new_services': 'New Services',
  'dashboard.new_products': 'New Products',
  'dashboard.users_with_conversion': 'with conversion',
  'dashboard.payment_history_tab': 'Payment history',
  'global.withdrawals': 'Withdrawals',
  'dashboard.users': 'Users',
  'dashboard.new': 'new',
  'dashboard.new_sellers': 'New Sellers',
  'dashboard.voice': 'Voice Posts',
  'dashboard.active_admins': 'Active Admins',
  'dashboard.online': 'online',
  'dashboard.app_downloads': 'App Downloads - Logged In',
  'dashboard.efficiency': 'Efficiency',
  'dashboard.click': 'clicks',
  'dashboard.new_user': 'new users',
  'dashboard.finance_overview': 'Finance Overview',
  'dashboard.total_in_wallet': 'Total in Wallet',
  'dashboard.pending_disbursement': 'Pending Disbursement',
  'dashboard.publishers': 'Publishers',
  'dashboard.content_activity': 'Content & Activity',
  'dashboard.blogs': 'Blogs',
  'dashboard.services': 'Services',
  'dashboard.products': 'Products',
  'dashboard.buyers_care_team': 'Buyers Care Team',
  'dashboard.buyers_care_team_percent':
    '{percent}% of buyers have registered interests',
  'global.affiliate_tier': 'Affiliate Tier',
  'global.affiliate_tier_history': 'Affiliate Tier History',
  'global.affiliate_tier_users': 'User Tiers',
  'global.affcampaign': 'Affiliate Campaign',
  'global.campaignUser': 'Campaign User',
  'global.conversion': 'Conversion',
  'global.clicks': 'Clicks',

  // SEO Management
  'sidebar.seo': 'SEO Management',
  'sidebar.seo.locations': 'Locations',
  'sidebar.seo.services': 'Services',
  'sidebar.seo.additionalNeeds': 'Additional Needs',
  'sidebar.seo.translations': 'Translations',
  'seo.locations.title': 'SEO Locations',
  'seo.locations.name': 'Location Name',
  'seo.locations.slug': 'Slug',
  'seo.locations.level': 'Level',
  'seo.locations.country': 'Country',
  'seo.locations.parent': 'Parent Location',
  'seo.locations.description': 'Description',
  'seo.locations.latitude': 'Latitude',
  'seo.locations.longitude': 'Longitude',
  'seo.locations.status': 'Status',
  'seo.locations.level.city': 'City',
  'seo.locations.level.district': 'District',
  'seo.locations.level.neighborhood': 'Neighborhood',
  'seo.locations.level.region': 'Region',
  'seo.services.title': 'SEO Services',
  'seo.services.name': 'Service Name',
  'seo.services.slug': 'Slug',
  'seo.services.category': 'Category',
  'seo.services.type': 'Type',
  'seo.services.type.service': 'Service',
  'seo.services.type.expert': 'Expert',
  'seo.services.icon': 'Icon',
  'seo.services.description': 'Description',
  'seo.additionalNeeds.title': 'Additional Needs',
  'seo.additionalNeeds.name': 'Need Name',
  'seo.additionalNeeds.slug': 'Slug',
  'seo.additionalNeeds.priority': 'Priority',
  'seo.additionalNeeds.description': 'Description',
  'seo.translations.title': 'SEO Service Translations',
  'seo.translations.add': 'Add Translation',
  'seo.translations.edit': 'Edit Translation',
  'seo.translations.service': 'Service',
  'seo.translations.country': 'Country',
  'seo.translations.name': 'Translated Name',
  'seo.translations.description': 'Translated Description',
  'voucher.voice_translate': 'Voice Translate',
  'global.count': 'Count',
  'global.count_of_users': 'Count of users',
  'global.user_relationships': 'User Relationships',
  'global.scope': 'Scope',
  'global.network': 'Network',
  'analyticsReport.menu': 'Traffic Report',
  'analyticsReport.title': 'PostHog Dashboard',
  'analyticsReport.info': 'Manual metric table for admin reporting',
  'analyticsReport.subtitle': 'Summary from PostHog',
  'analyticsReport.lastSync': 'Last updated',
  'analyticsReport.sync': 'Sync data',
  'analyticsReport.addManual': 'Add manual metric',
  'analyticsReport.tableTitle': 'Metric summary table',
  'analyticsReport.searchMetric': 'Search metric',
  'analyticsReport.reload': 'Reload',
  'analyticsReport.refresh': 'Refresh',
  'analyticsReport.metric': 'Metric',
  'analyticsReport.metricLabel': 'Metric label',
  'analyticsReport.metricKey': 'Metric key',
  'analyticsReport.date': 'Date',
  'analyticsReport.reportDate': 'Report date',
  'analyticsReport.updatedDate': 'Updated date',
  'analyticsReport.currentValue': 'Current value',
  'analyticsReport.source': 'Source',
  'analyticsReport.platform': 'Platform',
  'analyticsReport.lastUpdated': 'Last updated',
  'analyticsReport.updatedBy': 'Updated by',
  'analyticsReport.actions': 'Actions',
  'analyticsReport.editMetric': 'Edit metric',
  'analyticsReport.history': 'History',
  'analyticsReport.reason': 'Reason',
  'analyticsReport.time': 'Time',
  'analyticsReport.action': 'Action',
  'analyticsReport.previousValue': 'Previous value',
  'analyticsReport.loadFailed': 'Failed to load analytics report',
  'analyticsReport.historyLoadFailed': 'Failed to load metric history',
  'analyticsReport.syncEmpty': 'No PostHog metrics to sync',
  'analyticsReport.syncedFromPosthog': 'Synced from PostHog',
  'analyticsReport.syncSuccess': 'PostHog data synced',
  'analyticsReport.syncFailed': 'Failed to sync PostHog data',
  'analyticsReport.syncWebOnly': 'PostHog sync is available for Web only',
  'analyticsReport.deletedFromAdmin': 'Deleted from admin',

  // Signup tracking pages
  'trackingPage.menu': 'Signup Attribution (Ads)',
  'trackingPage.manager': 'Signup Attribution',
  'trackingPage.tab.campaign': 'Ads campaigns',
  'trackingPage.tab.page': 'By page',
  'trackingPage.tab.registry': 'Tracking page setup',
  'trackingPage.col.page': 'Page',
  'trackingPage.col.label': 'Label',
  'trackingPage.col.match': 'Match',
  'trackingPage.col.sort': 'Sort',
  'trackingPage.col.actions': 'Actions',
  'trackingPage.col.campaign': 'Campaign',
  'trackingPage.col.source': 'Source',
  'trackingPage.col.signups': 'Signups',
  'trackingPage.col.email': 'Email',
  'trackingPage.col.name': 'Name',
  'trackingPage.col.registeredAt': 'Registered at',
  'trackingPage.col.care': 'Care',
  'trackingPage.messageUser': 'Message this customer',
  'trackingPage.openFullChat': 'Open full chat page',
  'trackingPage.care.none': 'Not contacted',
  'trackingPage.care.waiting': 'Waiting',
  'trackingPage.care.done': 'Contacted',
  'trackingPage.care.none.hint': 'Not contacted — no conversation yet',
  'trackingPage.care.waiting.hint': 'Waiting — customer replied last, your turn',
  'trackingPage.care.done.hint': 'Contacted — you replied last, awaiting customer',
  'care.unassigned': 'Unassigned',
  'care.alreadyContacted': 'A colleague has already messaged this customer',
  'care.viewThread': 'View thread',
  'care.backToMine': 'Back to my thread',
  'care.readOnlyOf': 'Read-only view of the thread for {name}',
  'care.readFailed': 'Could not read this thread',
  'care.noMessages': 'No messages yet',
  'care.othersContacted': '{count} people messaged',
  'care.othersWaiting': 'Customer is waiting on {name}',
  'care.someoneWaiting': 'Customer is waiting for a reply in a colleague thread',
  'care.theyReplied': 'replied',
  'care.customerWaiting': 'has not replied',
  'care.currentOwner': 'Owner: {name}',
  'care.claim': 'Take this customer',
  'care.save': 'Save',
  'care.saved': 'Saved',
  'care.saveFailed': 'Could not save',
  'care.notePlaceholder': 'Note for whoever picks this up next: what they asked, when to call back, why they declined…',
  'care.filter.unassigned': 'Only unassigned customers',
  'trackingPage.col.method': 'Method',
  'trackingPage.col.landing': 'Landing page',
  'trackingPage.col.registration': 'Registration page',
  'trackingPage.col.details': 'Details',
  'trackingPage.col.user': 'User',
  'trackingPage.col.pages': 'Pages',
  'trackingPage.col.campaignName': 'Campaign name',
  'trackingPage.dateRange': 'Date range',
  'trackingPage.viewSignups': 'View signups',
  'trackingPage.search.user': 'Search email or name',
  'trackingPage.empty.pages': 'No pages',
  'trackingPage.empty.campaigns': 'No campaigns',
  'trackingPage.empty.users': 'No signups',
  'trackingPage.col.fromGoogleAds': 'From Google Ads',
  'trackingPage.search.registry': 'Search by page or label',
  'trackingPage.search.campaign': 'Search campaign (id / name)',
  'trackingPage.apply': 'Apply',
  'trackingPage.activeOnly': 'Active only',
  'trackingPage.activeOnlyHint': 'Only count pages that are currently active',
  'trackingPage.totalSignups': 'Total signups (all listed pages)',
  'trackingPage.fromAds': 'From ads',
  'trackingPage.organic': 'Organic',
  'trackingPage.organicTag': 'Organic / Direct',
  'trackingPage.viewing': 'Viewing: {range}',
  'trackingPage.allTime': 'All time',
  'trackingPage.rangeHint': 'Signups are totalled per campaign within this date range.',
  'trackingPage.refresh': 'Reload with the current filters',
  'trackingPage.preset.7d': 'Last 7 days',
  'trackingPage.preset.30d': 'Last 30 days',
  'trackingPage.preset.thisMonth': 'This month',
  'trackingPage.preset.lastMonth': 'Last month',
  'trackingPage.totalHint': 'Every account created in this date range, ads and organic together.',
  'trackingPage.fromAdsHint': 'Signups that arrived with a campaign id (utm_campaign or a Google Ads click).',
  'trackingPage.organicHint': 'Signups with no campaign id: search, direct links, referrals, or ad links missing their tracking parameters.',
  'trackingPage.statNoteAllSources': 'All sources',
  'trackingPage.statNoteAllPages': 'All tracked pages',
  'trackingPage.statNoteActivePages': 'Active pages only',
  'trackingPage.totalPagesHint': 'Signups whose first visited page matches one of the pages listed below, within this date range.',
  'trackingPage.statNoteShare': '{pct}% of signups',
  'trackingPage.signupsColHint': 'Click a number to see the accounts behind it.',
  'trackingPage.signupsOf': 'Signups · {name}',
  'trackingPage.noCampaignName': '{id} — no name yet, this campaign has not synced from Google Ads',
  'trackingPage.gclidHint': 'Google Click ID — this signup came from a Google ad click',
  'trackingPage.yes': 'Yes',
  'trackingPage.no': 'No',
  'trackingPage.deleteRow': 'Delete this tracking page?',
  'trackingPage.deleteUser': 'Delete this account?',
  'trackingPage.deleteUserHint': '{email} will be deleted (soft delete, recoverable).',
  'trackingPage.deleteUserDone': 'Account {email} deleted',
  'trackingPage.deleteUserFailed': 'Could not delete the account',
  'trackingPage.saved': 'Tracking page saved',
  'trackingPage.saveFailed': 'Could not save the tracking page',
  'trackingPage.deleted': 'Deleted',
  'trackingPage.deleteFailed': 'Delete failed',
  'trackingPage.fetchFailed': 'Could not load tracking pages',
  'trackingPage.statsFailed': 'Could not load statistics',
  'trackingPage.campaignStatsFailed': 'Could not load campaign statistics',
  'trackingPage.usersFailed': 'Could not load the signup list',
  'trackingPage.form.addTitle': 'Add tracking page',
  'trackingPage.form.editTitle': 'Edit tracking page',
  'trackingPage.form.pageLabel': 'Page',
  'trackingPage.form.pageHint': 'Matched against users.initial_user_page, which now stores the origin too — e.g. https://www.strongbody.ai/creators. The query string, the locale prefix and dynamic ids are stripped, so /voice/86535/earn is stored as /voice/earn.',
  'trackingPage.form.pageRequired': 'Page is required',
  'trackingPage.form.matchHint': 'exact = equals the page value; prefix = anything starting with it (groups "/creators?utm=fb", "/creators/...").',
  'trackingPage.form.labelHint': 'Display name for reports. Falls back to the page when empty.',

  // Appointment requests - leads submitted from a service detail page.
  'longevity_consult.title': 'Longevity Consults',
  'longevity_consult.create_title': 'New consult request',
  'longevity_consult.edit_title': 'Consult request',
  'longevity_consult.total': 'Total requests',
  'longevity_consult.submitted_at': 'Submitted',
  'longevity_consult.contact': 'Contact',
  'longevity_consult.full_name': 'Full name',
  'longevity_consult.country': 'Country (ISO code)',
  'longevity_consult.phone': 'Phone or WhatsApp',
  'longevity_consult.package': 'Package',
  'longevity_consult.package_starter': 'Starter',
  'longevity_consult.package_active': 'Active',
  'longevity_consult.package_longevity': 'Longevity',
  'longevity_consult.preferred_time': 'Preferred time',
  'longevity_consult.preferred_date': 'Preferred day',
  'longevity_consult.preferred_slot': 'Preferred time',
  'longevity_consult.time_zone': 'Time zone',
  'longevity_consult.slot_morning': 'Morning (8–12)',
  'longevity_consult.slot_afternoon': 'Afternoon (12–17)',
  'longevity_consult.slot_evening': 'Evening (17–20)',
  'longevity_consult.answers': 'Answers',
  'longevity_consult.companion_mode': 'How to be accompanied',
  'longevity_consult.mode_close': 'Close companionship',
  'longevity_consult.mode_autonomy': 'High autonomy',
  'longevity_consult.mode_unsure': 'Not sure yet',
  'longevity_consult.focus_areas': 'Focus',
  'longevity_consult.focus_sleep': 'Sleep',
  'longevity_consult.focus_energy': 'Energy',
  'longevity_consult.focus_movement': 'Movement',
  'longevity_consult.focus_nutrition': 'Nutrition',
  'longevity_consult.focus_stress': 'Stress',
  'longevity_consult.note': 'Visitor note',
  'longevity_consult.admin_note': 'Admin note',
  'longevity_consult.admin_note_placeholder': 'Call outcome, next step… (internal only)',
  'longevity_consult.user': 'Account',
  'longevity_consult.guest': 'Guest',
  'longevity_consult.locale': 'Language',
  'longevity_consult.source_url': 'Source page',
  'longevity_consult.status_new': 'New',
  'longevity_consult.status_contacted': 'Contacted',
  'longevity_consult.status_scheduled': 'Scheduled',
  'longevity_consult.status_closed': 'Closed',
  'longevity_consult.all_packages': 'All packages',
  'longevity_consult.all_statuses': 'All statuses',
  'longevity_consult.search_placeholder': 'Search #ID, name, email, phone, note',
  'longevity_consult.required': 'This field is required',
  'longevity_consult.invalid_email': 'Invalid email',
  'longevity_consult.invalid_country': 'Use a 2-letter country code, e.g. VN',
  'longevity_consult.phone_code': 'Country code',
  'longevity_consult.invalid_phone': 'Enter a valid number for the selected country code',
  'longevity_consult.load_error': 'Could not load consult requests',
  'longevity_consult.save_error': 'Could not save the consult request',
  'longevity_consult.delete_error': 'Could not delete the consult request',
  'longevity_consult.created': 'Consult request created',
  'longevity_consult.updated': 'Consult request updated',
  'longevity_consult.status_updated': 'Status updated',
  'longevity_consult.deleted': 'Consult request deleted',
  'longevity_consult.delete_confirm': 'Delete this consult request?',
  'appointment_request.title': 'Appointment Requests',
  'appointment_request.detail_title': 'Appointment request',
  'appointment_request.total': 'Total requests',
  'appointment_request.submitted_at': 'Submitted',
  'appointment_request.buyer': 'Buyer',
  'appointment_request.guest': 'Guest',
  'appointment_request.registered_buyer': 'Registered buyer',
  'appointment_request.organization': 'Organization',
  'appointment_request.budget': 'Budget',
  'appointment_request.insurance': 'Insurance',
  'appointment_request.timeframe': 'Timeframe',
  'appointment_request.notes': 'Notes',
  'appointment_request.contact_preference': 'Contact preference',
  'appointment_request.all_categories': 'All categories',
  'appointment_request.all_statuses': 'All statuses',
  'appointment_request.search_placeholder': 'Search name, email or phone',
  'appointment_request.status_new': 'New',
  'appointment_request.status_contacted': 'Contacted',
  'appointment_request.status_closed': 'Closed',
  'appointment_request.status_updated': 'Status updated',
  'appointment_request.status_update_error': 'Could not update the status',
  'appointment_request.load_error': 'Could not load appointment requests',
  'appointment_request.budget_flexible': 'Best option available',
  'appointment_request.budget_capped': 'Capped',
  'appointment_request.insurance_none': 'No insurance',
  'appointment_request.insurance_insured': 'Insured',
  'appointment_request.timeframe_researching': 'Just researching',
  'appointment_request.timeframe_few_months': 'Within a few months',
  'appointment_request.timeframe_local': 'Local / soon',
  'appointment_request.timeframe_date_range': 'Specific dates',
  'appointment_request.timeframe_asap': 'As soon as available',
  'appointment_request.timeframe_within_3_months': 'Within the next 3 months',
  'appointment_request.timeframe_specific_date': 'Specific date',
  'appointment_request.timeframe_not_sure': 'Not sure yet',
  'appointment_request.contact_phone_email': 'Phone & email',
  'appointment_request.contact_email_only': 'Email only',
  'appointment_request.contact_other': 'Other',
  'appointment_request.contact_email': 'Email',
  'appointment_request.contact_whatsapp': 'WhatsApp',
  'appointment_request.contact_phone_call': 'Phone call',
  'appointment_request.preferred_language': 'Preferred language',
  'appointment_request.section_timing': 'Preferred timing',
  'appointment_request.section_contact': 'Contact details',
  'appointment_request.section_legacy': 'Earlier form answers',
  'appointment_request.full_name': 'Full name',
  'appointment_request.whatsapp_number': 'WhatsApp number',
  'appointment_request.no_preference': 'No preference',
  'appointment_request.message': 'Message',
  'appointment_request.type': 'Type',
  'appointment_request.all_types': 'All types',
  'appointment_request.type_appointment': 'Appointment',
  'appointment_request.type_intro_call': 'Intro call',
  'appointment_request.seller': 'Seller',
  'appointment_request.service_or_seller': 'Service / seller',
  // Pro Referral (campaign 64): free Pro Provider via 20 paid referrals
  'pro_referral.menu': 'Pro Referral',
  'pro_referral.title': 'Pro Referral — free Pro',
  'pro_referral.info_message': 'Providers invite {goal} new users with the campaign 64 code; each must make at least one successful paid purchase (services must be Completed) within the participation window.',
  'pro_referral.info_description': 'Goal reached → the claim goes to the <b>Pending review</b> tab. Approving grants Pro Provider (plan 36) for 12 months, free, never renewed. Participation window, start/end dates and on/off are set in <link>Affiliate campaign</link> (campaign #64, Duration field).',
  'pro_referral.load_list_error': 'Could not load Pro Referral participants',
  'pro_referral.tab_all': 'All',
  'pro_referral.hint_pending_review': 'The provider reached the goal in time. Check the invitee list, then Approve (12 months of Pro Provider free) or Reject (reason required, the provider will see it).',
  'pro_referral.hint_in_progress': 'Within the participation window, goal not reached yet.',
  'pro_referral.hint_rewarded': 'Approved and Pro Provider granted.',
  'pro_referral.hint_rejected': 'Claim rejected.',
  'pro_referral.hint_expired': 'Deadline passed without reaching the goal.',
  'pro_referral.hint_superseded': 'The provider bought Pro before reaching the goal — challenge closed.',
  'pro_referral.hint_all': 'Everyone who joined campaign 64.',
  'pro_referral.search_placeholder': 'Name, email, user id, invite code',
  'pro_referral.no_name': '(no name)',
  'pro_referral.user_code': 'user #{id} · code {code}',
  'pro_referral.col_provider': 'Provider',
  'pro_referral.col_progress': 'Progress',
  'pro_referral.col_joined': 'Joined',
  'pro_referral.col_deadline': 'Deadline',
  'pro_referral.col_goal_reached': 'Goal reached',
  'pro_referral.col_status': 'Status',
  'pro_referral.col_actions': 'Actions',
  'pro_referral.purchased': 'purchased',
  'pro_referral.invited_count': 'Invited {count}',
  'pro_referral.pending_count': ' · {count} awaiting completion',
  'pro_referral.btn_review': 'Review',
  'pro_referral.btn_detail': 'Details',
  'pro_referral.total_participants': '{count} participants',
  'pro_referral.total_invitees': '{count} people',
  'pro_referral.status_pending_review': 'Pending review',
  'pro_referral.status_in_progress': 'In progress',
  'pro_referral.status_rewarded': 'Approved · Pro granted',
  'pro_referral.status_rejected': 'Rejected',
  'pro_referral.status_expired': 'Expired',
  'pro_referral.status_superseded': 'Has Pro (bought)',
  'pro_referral.invitee_qualified': 'Purchased',
  'pro_referral.invitee_pending': 'Awaiting completion',
  'pro_referral.invitee_registered': 'Signed up',
  'pro_referral.txn_service': 'Service / booking',
  'pro_referral.txn_product': 'Product',
  'pro_referral.txn_subscription': 'Subscription',
  'pro_referral.txn_credit': 'Credit',
  'pro_referral.ref_service': 'Offer',
  'pro_referral.ref_product': 'Order',
  'pro_referral.ref_subscription': 'User subscription',
  'pro_referral.ref_credit': 'Credit purchase',
  'pro_referral.claim_pending': 'Pending review',
  'pro_referral.claim_approved': 'Approved',
  'pro_referral.claim_rejected': 'Rejected',
  'pro_referral.load_detail_error': 'Could not load the participant',
  'pro_referral.load_invitees_error': 'Could not load the invitee list',
  'pro_referral.approve_success': 'Approved — Pro Provider granted',
  'pro_referral.reject_success': 'Claim rejected',
  'pro_referral.action_error': 'The action failed',
  'pro_referral.view_only': 'This claim is pending review. Only Super, Admin or Lead Operation can approve or reject it.',
  'pro_referral.active_pro_warning': 'The provider has an active Pro plan until {date} (plan #{plan}, {provider}).',
  'pro_referral.active_pro_warning_desc': 'If approved, the free 12 months start right after this end date.',
  'pro_referral.field_provider': 'Provider',
  'pro_referral.field_user_code': 'User ID / invite code',
  'pro_referral.field_status': 'Status',
  'pro_referral.field_progress': 'Progress',
  'pro_referral.progress_detail': 'purchased · invited {invited}',
  'pro_referral.field_joined': 'Joined',
  'pro_referral.field_deadline': 'Deadline',
  'pro_referral.window_days': '({days} days)',
  'pro_referral.days_left': ' · {days} days left',
  'pro_referral.field_goal_reached': 'Goal reached at',
  'pro_referral.section_claim': 'Pro claim',
  'pro_referral.field_claim_status': 'Claim status',
  'pro_referral.field_qualified_count': 'Qualified at submission',
  'pro_referral.field_reviewer': 'Reviewer',
  'pro_referral.field_reviewed_at': 'Reviewed at',
  'pro_referral.field_reject_reason': 'Rejection reason',
  'pro_referral.field_note': 'Note',
  'pro_referral.field_granted_plan': 'Granted plan',
  'pro_referral.granted_plan_value': 'User subscription #{id} · {start} → {end}',
  'pro_referral.section_invitees': 'Invitees ({count})',
  'pro_referral.invitees_hint': 'Only new accounts that signed up with the invite code before the deadline count. "Counted purchase" is the first qualifying purchase — check it before approving (e.g. many accounts buying the provider\'s own service).',
  'pro_referral.col_invitee': 'Invitee',
  'pro_referral.col_signup': 'Signed up',
  'pro_referral.col_counted_txn': 'Counted purchase',
  'pro_referral.btn_reject': 'Reject',
  'pro_referral.btn_approve': 'Approve & grant Pro',
  'pro_referral.cancel': 'Cancel',
  'pro_referral.approve_title': 'Approve the claim & grant Pro Provider',
  'pro_referral.reject_title': 'Reject the claim',
  'pro_referral.approve_body': 'Grant <b>Pro Provider (plan 36)</b> for 12 months, free, never renewed, to <b>{name}</b>. The provider is notified right away. This cannot be undone.',
  'pro_referral.note_label': 'Internal note (optional)',
  'pro_referral.reject_body': 'The provider will be notified with the reason (write it in English) and cannot submit again.',
  'pro_referral.reason_label': 'Rejection reason',
  'pro_referral.reason_required': 'Enter a rejection reason',
  'pro_referral.reason_min': 'At least 5 characters',
  'pro_referral.reason_placeholder': 'E.g. Several invited accounts look like fake accounts.',
};
export default lang;
